import { jsx as s, Fragment as U, jsxs as C } from "react/jsx-runtime";
import { createContext as F, useContext as x, useMemo as m, useCallback as c, useEffect as f, useState as O } from "react";
import { useAuthUserOrNull as W, useAuthRoutes as _, useTenantsState as H, useAuth as Y, useAuthActions as G, FronteggProvider as K } from "@frontegg/react";
import { useNavigate as w, useLocation as E, Navigate as S, Outlet as k, createHashRouter as V, createBrowserRouter as Z, createRoutesFromElements as j, Route as T } from "react-router-dom";
import { a as J } from "./hooks-DBeunhio.js";
import "react-i18next";
import { jwtDecode as Q } from "jwt-decode";
var D = /* @__PURE__ */ ((e) => (e.ADMIN = "Admin", e.READ_ONLY = "ReadOnly", e.SALES_MANAGER = "salesmanager", e.SALES_EMPLOYEE = "salesemployee", e))(D || {});
class B {
  constructor({ id: n, name: t, email: r, tenantId: i, roles: l }) {
    this.id = n, this.name = t, this.email = r, this.tenantId = i, this.roles = l;
  }
  hasRole(n) {
    return this.roles.includes(n);
  }
}
function z(e) {
  return e.map(
    (n) => Object.values(D).find((t) => t === n)
  ).filter((n) => !!n);
}
function $(e) {
  return new B({
    id: e.id,
    name: e.name,
    email: e.email,
    tenantId: e.tenantId,
    roles: z(e.roles.map((n) => n.key))
  });
}
function X(e) {
  return new B({
    id: e.sub,
    name: e.name,
    email: e.email,
    tenantId: e.tenantId,
    roles: z(e.roles)
  });
}
const y = F({
  user: null,
  logout: () => null,
  login: () => null,
  loginUrl: "",
  isAuthenticated: !1,
  unauthorizedPageRedirectUrl: "",
  tenantName: ""
}), v = () => x(y), ee = ({ children: e, unauthorizedPageRedirectUrl: n }) => {
  var g;
  const t = W(), { loginUrl: r } = _(), { activeTenant: i } = H(), l = m(
    () => t ? $(t) : null,
    [t]
  ), a = Y(), { logout: o } = G(), { isAuthenticated: h } = a, u = w(), p = c(() => o(), [o]), d = c(() => {
    u(r);
  }, [u, r]);
  return /* @__PURE__ */ s(
    y.Provider,
    {
      value: {
        user: l,
        logout: p,
        login: d,
        isAuthenticated: h,
        loginUrl: r,
        unauthorizedPageRedirectUrl: n,
        accessToken: (g = a.user) == null ? void 0 : g.accessToken,
        tenantName: (i == null ? void 0 : i.name) ?? ""
      },
      children: e
    }
  );
}, Te = ({ requiredRoles: e }) => {
  const n = E(), { user: t, isAuthenticated: r, loginUrl: i, unauthorizedPageRedirectUrl: l } = v();
  return !r || !t ? /* @__PURE__ */ s(S, { to: i, state: { from: n.pathname } }) : e && !e.some((a) => t.hasRole(a)) ? /* @__PURE__ */ s(S, { to: l }) : /* @__PURE__ */ s(k, {});
}, ne = ({ redirectTarget: e }) => {
  const { loginUrl: n, isAuthenticated: t } = v();
  return E().pathname === n && !t ? null : /* @__PURE__ */ s(S, { to: e });
}, te = {
  en: {
    loginBox: {
      login: {
        title: "Sign-in",
        signUpMessage: "Don't have an account?",
        signUpLink: "Sign up",
        forgotPassword: "Forgot password?",
        emailInputLabel: "Email",
        emailInputPlaceholder: "name@example.com",
        // emailOrPhoneInputLabel: 'Email / phone number',
        // emailOrPhonePlaceHolder: 'Enter email or phone number',
        passwordInputLabel: "Password",
        passwordInputPlaceholder: "Enter your password",
        login: "Sign in",
        continue: "Continue",
        emailMustBeValid: "Invalid email format. Make sure your email is correct",
        emailIsRequired: "Email is required",
        passwordMustBeCharacters: "Password must be at least {{length}} characters",
        passwordIsRequired: "Password is required",
        // signInWithPasskey: 'Sign in with passkey',
        invalidTitle: "Couldn't sign you in",
        signInWithSocialLogin: "or sign in with",
        backToLogin: "Back to Sign-in",
        mfaTitle: "Multi-factor authentication",
        // mfaSubtitle: 'Choose one of these methods to log in',
        // mfaAuthenticatorTitle: 'Check your authenticator app',
        mfaInputLabel: "Please enter the six-digit code from your authenticator app",
        mfaCodeIsRequired: "Code is required",
        mfaCodeLengthAtLeast6: "Code must be at least 6 characters",
        mfaRememberThisDevice: "Don't ask again on this device for {{count}} days",
        // mfaRememberLongerThenYear: "Don't ask again on this device",
        disableMultiFactorTitle: "Having trouble?",
        disableMultiFactorMessage: "to disable Multi-Factor with recovery code",
        recoverMfaTitle: "MFA recovery code",
        // recoverMfaMessage:
        //   'Enter your recovery code to temporarily disable MFA',
        disabledMultiFactorClickHereButton: "Click here",
        enterRecoveryCode: "Please enter your MFA recovery code",
        disabledMultiFactorButton: "Disable MFA",
        twoFactorCodeIsRequired: "Code is required",
        twoFactorCodeLengthAtLeast8: "Min length is 8 characters",
        missingPolicyErrorMessage: "Seems like we are having trouble loading your configuration",
        magicLinkTitle: "Magic link sent!",
        magicLinkText: "We have sent an email to {{email}} with a link to get you signed in quickly.",
        magicLinkResend: "Resend",
        // magicLinkResending: 'Sending link...',
        invalidMagicLinkTitle: "Couldn't sign you in",
        invalidMagicLinkText: "A magic link can only be used once.",
        smsOtcTitle: "Verify your phone number",
        smsOtcMessage: "Please enter the six-digit code we have sent to {{phoneNumber}}",
        smsOtcChangePhoneMessage: "(not your number? change it here)",
        otcTitle: "Check your email",
        otcMessage: "We sent you a six digit code to {{email}}",
        otcInputLabel: "Enter the generated 6-digit code below",
        otcInputPlaceholder: "6 - digit code",
        otcCodeIsRequired: "",
        otcContinue: "Continue",
        otcHaventReceivedCode: "Haven't received it?",
        otcResend: "Resend code",
        // otcResending: 'Sending code...',
        otcInvalidLengthCode: "The code should have the 6 letter",
        ssoRedirectToMessage: "Taking you to your organization's sign-in page",
        failedOicdLoginTitle: "Failed to Login with SSO, try again later.",
        failedOicdBackToLogin: "Back to Sign-in",
        failedSamlBackToLogin: "Back to Sign-in",
        failedSamlDefaultError: "Failed to login with SSO, please try again later.",
        joinTenantTitle: "Join {{tenantName}}'s Account",
        failedJoinTenantTitle: "This invite link is not active",
        failedJoinTenantBackButton: "Back to Sign-in",
        forceMfaTitle: "Setup Authenticator",
        forceMfaMessage: " Use your phone to scan the following QR code with Google Authenticator or other authenticator apps.",
        forceMfaScanQueryDescription1: "Use your phone to scan the following QR code with ",
        forceMfaScanQueryDescription2: " or other authenticator apps.",
        forceMfaInputLabel: "Enter the generated 6-digit code below.",
        forceMfaInputPlaceholder: "Ex. 1 2 3 4 5 6",
        forceMfaVerifyButton: "Verify",
        forceMfaRememberThisDevice: "Don't ask again on this device for {{count}} days",
        // forceMfaRememberLongerThenYear: "Don't ask again on this device",
        splitLogin: {
          titleDescriptionComponent: {
            companyName: "",
            titleAfterCompanyName: "",
            titleBeforeCompanyName: "With {company name} you can start building",
            description: "Create your account and start use it today! It only takes a few seconds so sign in."
          },
          testimonialComponent: {
            testimonial1: {
              label: "John Doe",
              subtitle: "Software developer @Company",
              text: "We integrated Frontegg in just a few hours. We literally just needed to check the boxes to get started. Our dev team loves it."
            }
          },
          valuesComponent: {
            value1: "Every day, {company name} makes thousands of customers happy.",
            value2: "Create your account and start your journey with us.",
            value3: "{company name} helps you grow! Signup and choose your plan."
          }
        },
        disclaimerText: "I agree with the",
        termsLinkText: "Terms",
        termsLink: "https://app.termly.io/document/privacy-policy/71fec9f3-2088-475a-8106-9a590b6e0c0f",
        privacyLinkText: "Privacy Policy",
        privacyLink: "https://app.termly.io/document/privacy-policy/71fec9f3-2088-475a-8106-9a590b6e0c0f",
        termsAndPrivacyConjunctionText: "and",
        oneTouchLoginTitle: "Log in with Touch ID",
        oneTouchLoginMessage: "Log in with the touch of your finger",
        oneTouchLoginButton: "Log in with Touch ID",
        touchId: "Touch ID",
        androidLoginTitle: "Log in with Android",
        androidLoginMessage: "Get a notification on your Android",
        androidLoginButton: "Log in with Android",
        android: "Android",
        usbLoginTitle: "Log in with USB key",
        usbLoginMessage: "Plug in your USB key to log in",
        usbLoginButton: "Log in with USB key",
        usb: "USB Key",
        smsLoginTitle: "Log in with SMS",
        smsLoginMessage: "Enter your phone number to get a pin",
        smsLoginButton: "Log in with SMS",
        smsLoginChangePhoneTitle: "What's your number?",
        smsLoginChangePhoneMessage: "Enter your phone number to get a pin",
        smsLoginChangePhoneInputLabel: "Phone number",
        smsLoginChangePhoneButton: "Send me an SMS",
        smsLoginPinTitle: "Verify that it's you",
        smsLoginPinMessage: "Please enter the six-digit code we have sent to {{phoneNumber}}",
        smsLoginPinButton: "Verify",
        sms: "SMS",
        loginWelcomeTitle: "Welcome back",
        loginWelcomeSubtitleSubtitle: "How would you like to log in?",
        loginWelcomeKnownUserSubtitle: "Quickly log back into your account",
        registerNewQuickLoginTitle: "Great choice! But first, please log in with email",
        // registerNewQuickLoginTitleWithSocial:
        //   'Great choice! But first, please log in with email or social',
        registerNewQuickLoginSubtitle: "Then we'll set up login with {{type}} for you",
        phoneIsRequired: "Phone number is required",
        phoneIsInvalid: "Must be a valid phone number"
        // phoneFormatIsInvalid:
        //   'Invalid phone format. Make sure you added the country code',
        // forceEnrollMfaTitle: 'Set Up MFA',
        // forceEnrollMfaSubtitle: 'Set up one of these methods to log in',
        // forceEnrollMfaAuthenticatorApp: 'Authenticator app',
        // forceEnrollMfaAuthenticatorAppDescription:
        // 'Google Authenticator, Authy, etc',
        // forceEnrollMfaSMS: 'SMS',
        // forceEnrollMfaPlatform: 'Built-in Authenticator',
        // forceEnrollMfaCrossPlatform: 'Security Key',
        // forceEnrollMfaCrossPlatformDescription: 'USB key and mobile devices',
        // preEnrollMfaSMSTitle: "What's your number?",
        // preEnrollMfaSMSSubtitle: 'Enter your phone number to get a pin',
        // mfaSMSTitle: 'Verify your mobile number',
        // mfaSMSSubtitle:
        //   'Please enter the six-digit code we just sent to {{phoneNumber}}',
        // mfaSMSResendCode: 'Resend code',
        // enrollMfaSMSBackMessage: 'Go back',
        // moreWaysToAuthenticate: 'Authenticate another way',
        // loginMfaSMS: 'SMS',
        // loginMfaSMSDescription: 'Send an SMS code to {{phoneNumber}}',
        // loginMfaPlatform: 'Built-in Authenticator',
        // loginMfaPlatformDescription: 'Touch ID and Windows Hello',
        // loginMfaCrossPlatform: 'Security Key',
        // loginMfaCrossPlatformDescription: 'USB key and mobile devices',
        // loginMfaAuthenticatorApp: 'Authenticator app',
        // loginMfaAuthenticatorAppDescription: 'Google Authenticator, Authy, etc',
        // loginMfaAuthenticatorAppTitle: 'Authenticator app',
        // loginMfaHelpMessage: "Can't authenticate? Ask your admin for help ",
        // useRecoveryCode: 'Use your backup code',
        // preEnrollMfaSMSSubmitButtonMessage: 'Send SMS',
        // promptPasskeysTitle: 'Use passkeys for easier and more secure sign in',
        // promptFirstItemTitle: 'Better, faster sign in',
        // promptFirstItemSubtitle: 'Easily login to your account in one step.',
        // promptSecondItemTitle: 'Safer by design',
        // promptSecondItemSubtitle:
        // "Passkeys can't be guessed, leaked, or even phished",
        // promptThirdItemTitle: 'Passkeys are easy to use',
        // promptThirdItemSubtitle:
        // 'You can use Touch ID, Face ID, Windows Hello and more',
        // usePasskeys: 'Use passkeys',
        // continueToApp: 'Continue to app',
        // dontAskMeAgain: "Don't ask me again",
        // breachedPasswordTitle: 'Change your password now',
        // breachedPasswordSubtitle:
        //   'Your password was exposed in a data breach unrelated to this app. Please change it now to protect your account.',
        // sendPasswordResetEmailButton: 'Send password reset email',
        // skip: 'Skip for now',
        // breachedPasswordBackToSignIn: 'Back to Sign-in',
        // breachedPasswordSuccessTitle: 'Check your email',
        // breachedPasswordSuccessSubtitle:
        // 'We just sent a reset password link to {{email}}.',
        // breachedPasswordSuccessText:
        // 'Go to your email and click it to reset your password.',
        // genericLoginErrorMessage:
        // "We're facing some difficulties, Please try again",
        // mfaEmailCodeTitle: 'Verify your account',
        // mfaEmailCodeMessage:
        // 'To keep your account secure, we sent you a six digit code to {{email}}',
        // mfaEmailCodeContinueButton: 'Continue',
        // mfaEmailCodeResendNewCode: 'Resend a new code',
        // mfaEmailCodeResending: 'Sending code...',
      },
      acceptInvitation: {
        title: "Accept Invitation",
        successTitle: " You've joined  successfully!",
        successMessage: "You'll be redirected to the login screen in a few seconds. ",
        invalidTitle: "This invite link is no longer active",
        invalidMessage: "A sign in link can only be used once. For a new link, please contact the person who shared it with you.",
        invalidBackToLoginButton: "Back to Sign-in"
      },
      activateAccount: {
        title: "Activate your account",
        newPasswordInputLabel: "New password",
        newPasswordInputPlaceholder: "Set a password",
        newPasswordIsRequired: "Password is required",
        confirmPasswordInputLabel: "Confirm new password",
        confirmPasswordInputPlaceholder: "Re-enter password",
        confirmPasswordIsRequired: "Confirm password is required",
        confirmPasswordMustMatch: "Passwords must match",
        // confirmTermsAndConditionsIsRequired:
        //   'Please agree in order to continue',
        activateButton: "Activate",
        successTitle: "Successfully activated!",
        successMessage: "Now you can use your new password to log in to your account. The login page will appear automatically in a few seconds.",
        failedTitle: "Activation failed",
        failedMessage: "Please double check your activation url",
        linkExpiredTitle: "Activation link expired",
        linkExpiredMessage: "An activation link can only be used once",
        linkFailedTitle: "Activate account failed",
        linkFailedMessage: "Please double check your activation url",
        failedBackToLoginButton: "Back to Sign-in"
        // disclaimerText: 'By signing up, I agree with the',
        // disclaimerCheckboxLabel: 'I agree to the',
        // disclaimerTextRequired: 'Please agree in order to continue',
        // termsLinkText: 'Terms',
        // termsLink: 'https://frontegg.com',
        // privacyLinkText: 'Privacy Policy',
        // privacyLink: 'https://frontegg.com',
        // termsAndPrivacyConjunctionText: 'and',
      },
      recoveryMfa: {
        // header: 'MFA recovery code',
        title: "Recovery code can be used to disable multi-factor authentication in case you lose your phone.",
        recoveryCodeLabel: "Your recovery code",
        copyAndSaveCode: "Copy and save the code. we won't show it again.",
        continueButton: "Done"
      },
      forgetPassword: {
        title: "Forgot your password?",
        description: "Enter your registered email address – we'll send you a link to reset your password.",
        emailInputLabel: "Email",
        emailInputPlaceholder: "name@example.com",
        emailIsRequired: "Email is required",
        emailMustBeValid: "Must be a valid email",
        submitButtonText: "Reset password",
        backToLogin: "Back to Sign-in",
        resetEmailSentTitle: "Check your inbox",
        resetEmailSentMessage: "We've sent an email to {{email}} with instructions for resetting your password."
      },
      resetPhoneNumber: {
        emailInputLabel: "Email",
        emailInputPlaceholder: "name@example.com",
        emailIsRequired: "Email is required",
        emailMustBeValid: "Must be a valid email",
        continue: "Continue",
        resetPhoneNumberTitle: "Change phone number",
        resetPhoneOtcTitle: "Verify that it's you",
        resetPhoneOtcMessage: "Please enter the six-digit code we have sent to your email",
        changePhoneNumberTitle: "Enter your phone number",
        changePhoneNumberMessage: "Please enter your phone number below",
        phoneInputLabel: "Phone number",
        phoneInputPlaceholder: "Enter your phone number",
        phoneIsRequired: "Phone number is required",
        phoneIsInvalid: "Must be a valid phone number",
        backToLogin: "Back to Sign-in"
      },
      resetPassword: {
        title: "Reset password",
        description: "",
        newPasswordInputLabel: "New password",
        newPasswordInputPlaceholder: "Set a password",
        newPasswordIsRequired: "New password is required",
        confirmPasswordInputLabel: "Confirm new password",
        confirmPasswordInputPlaceholder: "Re-enter password",
        confirmPasswordIsRequired: "Confirm password is required",
        confirmPasswordMustMatch: "Passwords must match",
        resetPasswordButton: "Reset password",
        successTitle: "Password changed!",
        successMessage: "Now you can use your new password to log in to your account. The login page will appear automatically in a few seconds.",
        failedTitle: "Reset Password Failed",
        failedMessage: "Please double check your reset url",
        failedBackToLoginButton: "Back to Sign-in"
      },
      socialLogins: {
        // socialloginMainButtonTextPrefix: 'Continue with ',
        // socialloginButtonTextPrefix: '',
        // socialsignUpMainButtonTextPrefix: 'Continue with ',
        // socialsignUpButtonTextPrefix: '',
        // socialactivationMainButtonTextPrefix: 'Continue with ',
        // socialactivationButtonTextPrefix: '',
        loginButtonText: "Continue with",
        signupButtonText: "Login with {{providerName}}",
        activationButtonText: "Sign up with {{providerName}}",
        invalidTitle: "Couldn't sign you in",
        failedInvalidCallbackUrl: "Invalid callback url",
        failedBackToLogin: "Back to Sign-in"
      }
      // impersonate: {
      //   title: 'Impersonate user',
      //   failedTitle: 'Impersonation failed',
      //   failedMessage: 'Something went wrong. Please try impersonation again',
      //   expiredTitle: 'ActorToken expired',
      //   expiredMessage: 'Please generate new Actor Token for impersonation',
      //   impersonationIndicatorText:
      //     'You are impersonating {{userEmail}} in {{accountName}}',
      //   stopImpersonatingButton: 'Stop impersonating',
      // },
    },
    validation: {
      passwordMinLength: "{{length}} characters minimum",
      passwordMaxLength: "{{length}} characters maximum",
      passwordThreeRepeatedChars: "avoid 3 or more recurring characters",
      passwordAtLeastOneLowerLetter: "1 lowercase letter",
      passwordAtLeastOneUpperLetter: "1 capital letter",
      passwordAtLeastOneNumber: "1 number",
      passwordAtLeastOneSpecialChar: "1 special character"
    },
    validations: {
      passwordMinLength: "{{length}} characters minimum",
      passwordMaxLength: "{{length}} characters maximum",
      passwordThreeRepeatedChars: "avoid 3 or more recurring characters",
      passwordAtLeastOneLowerLetter: "1 lowercase letter",
      passwordAtLeastOneUpperLetter: "1 capital letter",
      passwordAtLeastOneNumber: "1 number",
      passwordAtLeastOneSpecialChar: "1 special character"
    },
    adminPortal: {
      navigation: {
        workspace: "Workspace",
        allAccounts: "All Accounts",
        poweredBy: "Powered by",
        profile: "Profile",
        privacy: "Security",
        personalApiTokens: "Personal Tokens",
        usage: "Usage",
        account: "Account Details",
        users: "Users",
        // groups: 'Groups',
        allUsers: "All Users",
        roles: "Roles",
        security: "Security",
        sso: "SSO",
        // provisioning: 'Provisioning',
        audits: "Audit Logs",
        webhooks: "Webhooks",
        apiTokens: "API Tokens",
        subscriptions: "Subscription",
        login: "Login"
        // managed: 'Managed',
      },
      // provisioning_Header: {
      //   title: 'Provisioning Connections',
      //   addConnection: 'Add Connection',
      // },
      // provisioning_Table: {
      //   createdAtColumn: 'Created At',
      //   nameColumn: 'Name',
      //   providerColumn: 'Provider',
      //   statusColumn: 'Status',
      //   usersColumn: 'Users',
      //   emptyStateTitle: "You haven't configured provisioning yet",
      //   emptyStateSubTitle:
      //     'Connect to an identity provider to see connections',
      //   deleteConnectionAction: 'Delete configuration',
      //   pauseConnectionAction: 'Pause provisioning',
      //   resumeConnectionAction: 'Resume provisioning',
      //   linkedStatusChip: 'Linked',
      //   pausedStatusChip: 'Paused',
      //   pendingStatusChip: 'Pending',
      // },
      // provisioning_AddConnectionDialog: {
      //   dialogTitle: 'Add New Provisioning Connection',
      //   doneBtn: 'Done',
      //   submitBtn: 'Submit',
      //   cancelBtn: 'Cancel',
      //   nameLabel: 'Name',
      //   directoryProviderLabel: 'Directory Provider (optional)',
      //   namePlaceholder: 'Add name',
      //   directoryProviderPlaceholder: 'Add Directory Provider',
      //   provisioningToken: 'Authorization Token',
      //   provisioningUrl: 'Provisioning URL',
      //   provisioningTokenAlert:
      //     'The Authorization Token will not be visible again. Paste it in your identity provider before clicking done.',
      //   setUpIntegrationSubTitle:
      //     'Copy the credentials below and paste them in your identity provider to complete the integration.',
      //   setUpIntegrationTitle: 'Set up integration',
      //   validation_requiredField: '{{name}} is required',
      // },
      // provisioning_deleteConnectionDialog: {
      //   dialogTitle: 'Delete {{name}} connection',
      //   textPartOne: 'Do you really want to delete',
      //   textPartTwo:
      //     "If you delete it you won't be able to undo the process. All that remains is to create a new one.",
      //   deleteBtn: 'Delete',
      //   cancelBtn: 'Cancel',
      // },
      profile: {
        pageTitle: "Profile",
        name: "Name",
        email: "Email",
        phone: "Phone Number",
        address: "Address",
        jobTitle: "Job Title",
        informationTitle: "Basic Profile Information",
        // externallyManaged: 'Managed externally',
        // externallyManagedTooltip:
        //   'Your profile is managed by a third party. Visit your identity provider or contact an admin to edit your profile.',
        uploadImage: "Upload Image",
        removeImage: "Remove Image",
        removeImageTitle: "Remove Image",
        removeImageMessage: "Are you sure you want to remove your image?",
        removeImageButton: "Remove",
        removeImageCancelButton: "Cancel"
        // disabledEditPhoneNumberTooltip:
        //   'You can update your phone number in the SMS login section of the "Privacy & Security" page',
      },
      profile_EditName: {
        title: "Edit Name",
        displayNameInputLabel: "Display Name",
        firstNameInputLabel: "First Name",
        firstNameIsRequired: "First name is required",
        lastNameInputLabel: "Last Name",
        nameTitle: "Title",
        nameTitle_mr: "Mr",
        nameTitle_mrs: "Mrs",
        nameTitle_miss: "Miss",
        nameTitle_ms: "Ms",
        nameTitle_dr: "Dr",
        nameTitle_phd: "PhD",
        cancel: "Cancel",
        save: "Save"
      },
      profile_EditJobTitle: {
        title: "Edit Job Title",
        jobTitleInputLabel: "Job Title",
        cancel: "Cancel",
        save: "Save"
      },
      profile_EditPhone: {
        title: "Edit Phone Number",
        phoneInputLabel: "Phone Number",
        phoneIsRequired: "Phone number is required",
        phoneIsInvalid: "Must be a valid phone number",
        cancel: "Cancel",
        save: "Save"
      },
      profile_EditAddress: {
        title: "Edit Address",
        address1InputLabel: "Address 1",
        address1IsRequired: "Address 1 is required",
        address2InputLabel: "Address 2",
        address2IsRequired: "Address 2 is required",
        cityInputLabel: "City",
        cityIsRequired: "City is required",
        stateInputLabel: "State",
        stateInputIsRequired: "State is required",
        postCodeInputLabel: "Postcode",
        postCodeIsInvalid: "Must be a valid post code",
        postCodeIsRequired: "Postcode is required",
        countryInputLabel: "Country",
        countryInputPlaceholder: "Select your Country",
        countryIsRequired: "Country is required",
        cancel: "Cancel",
        save: "Save"
      },
      personalTokens: {
        pageTitle: "Personal Access Tokens",
        searchInputPlaceholder: "Search for any text...",
        generateTokenButton: "Generate Token",
        noApiTokensYet: "You don't have any API tokens yet.",
        noApiTokensYetDescription: "Add new api token to see the results in your table",
        noResultFound: "No Result found",
        noResultFoundDescription: "It seems we can't find any results based on your search.",
        clientIdHeader: "Description",
        createdOnHeader: "Created On",
        // typeHeader: 'Type',
        // expiresHeader: 'Expires',
        // accessTokenType: 'Access Token',
        // clientCredentialsType: 'Client Credentials',
        // expiredChipLabel: 'Expired',
        // neverChipLabel: 'Never',
        deleteApiTokenAction: "Delete API Token"
      },
      personalTokens_AddToken: {
        title: "Generate Token",
        successTitle: "Your API key was successfully generated!",
        descriptionInputLabel: "Description",
        descriptionIsRequired: "Description is required",
        clientId: "Client ID",
        // accessToken: 'Access Token',
        // copyAndSaveAccessToken:
        //   "Copy and save the access token and below because we won't show it again.",
        secretKey: "Secret Key",
        copyAndSaveId: "Copy and save the ID and Secret below because we won't show it again.",
        cancel: "Cancel",
        create: "Create",
        done: "Done"
      },
      personalTokens_DeleteToken: {
        title: "Delete API Token?",
        areYouSureDeleteApiToken1: "Are you sure you want to delete",
        areYouSureDeleteApiToken2: "you won't be able to undo this process",
        cancel: "Cancel",
        delete: "Delete"
      },
      auditLogs: {
        pageTitle: "Audit Logs",
        searchInputPlaceholder: "Search for any text...",
        downloadCsv: "Download CSV",
        downloadCsvPrimaryButton: "Download",
        noResultFound: "No Result found",
        noResultFoundDescription: "It seems we can't find any results based on your search.",
        searchingPlaceholder: "Searching...",
        clear: "Clear",
        cancel: "Cancel",
        filter: "Filter",
        filterBy: "Filter By"
        // impersonatedByTooltip: 'Impersonated by:',
      },
      apiTokens: {
        pageTitle: "API Tokens",
        searchInputPlaceholder: "Search for any text...",
        generateTokenButton: "Generate Token",
        noApiTokensYet: "You don't have any nAPI tokens yet.",
        noApiTokensYetDescription: "Add new api token to see the results in your table",
        noResultFound: "No Result found",
        noResultFoundDescription: "It seems we can't find any results based on your search.",
        clientIdHeader: "Description",
        createdOnHeader: "Created On",
        createdByHeader: "Created By",
        rolesHeader: "Roles",
        // typeHeader: 'Type',
        // expiresHeader: 'Expires',
        // accessTokenType: 'Access Token',
        // clientCredentialsType: 'Client Credentials',
        // expiredChipLabel: 'Expired',
        // neverChipLabel: 'Never',
        deleteApiTokenAction: "Delete API Token"
      },
      apiTokens_AddToken: {
        title: "Generate Token",
        successTitle: "Your API key was successfully generated!",
        descriptionInputLabel: "Description",
        descriptionIsRequired: "Description is required",
        clientId: "Client ID",
        secretKey: "Secret Key",
        // accessToken: 'Access Token',
        copyAndSaveId: "Copy and save the ID and Secret below because we won't show it again.",
        // copyAndSaveAccessToken:
        //   "Copy and save the access token and below because we won't show it again.",
        rolesInputLabel: "Roles",
        rolesInputPlaceholder: "Select Role",
        rolesIsRequired: "At least one role is required",
        // expiresInputLabel: 'This token will expire',
        // neverExpire: 'Never',
        // expireAfter7Days: 'After 7 days',
        // expireAfter30Days: 'After 30 days',
        // expireAfter90Days: 'After 90 days',
        // expireAfter365Days: 'After 365 days',
        cancel: "Cancel",
        create: "Create",
        done: "Done"
      },
      apiTokens_DeleteToken: {
        title: "Delete API Token?",
        areYouSureDeleteApiToken1: "Are you sure you want to delete",
        areYouSureDeleteApiToken2: "you won't be able to undo this process",
        cancel: "Cancel",
        delete: "Delete"
      },
      accountSettings: {
        pageTitle: "Account Details",
        // tabTitle: 'Details',
        subtitle: "Settings",
        companyName: "Company Name",
        address: "Address",
        website: "Website",
        timezone: "Timezone",
        currency: "Currency",
        addCompanyButton: "Add company name",
        addAddressButton: "Add company address",
        addWebsiteButton: "Add website",
        setTimezoneButton: "Set default timezone",
        setCurrencyButton: "Set default currency"
        // emptyStateText:
        //   "This section is unavailable. For more information contact your organization's admin",
      },
      // customLoginTab: {
      //   tabTitle: 'Brand login box',
      //   addLogo: 'Add logo',
      //   emptyLogoText: 'Click or drop a logo file',
      //   logoMaxSize: '(max size 2MB, recommended svg file)',
      //   logoPlaceHolder: 'https://example.com/logo.png',
      //   uploadingLogo: 'Uploading...',
      //   upload: 'Upload',
      //   imageUrl: 'Image URL',
      //   primaryColor: 'Primary color',
      //   socialLoginPosition: 'Social login position',
      //   socialLoginPositionUp: 'Up',
      //   socialLoginPositionDown: 'Down',
      //   preview: 'Preview',
      //   cancel: 'Cancel',
      //   save: 'Save',
      //   logoInputError: 'Must be a valid image URL',
      // },
      accountSettings_EditAddress: {
        title: "Edit Address",
        address1InputLabel: "Address 1",
        address1IsRequired: "Address 1 is required",
        address2InputLabel: "Address 2",
        address2IsRequired: "Address 2 is required",
        cityInputLabel: "City",
        cityIsRequired: "City is required",
        stateInputLabel: "State",
        stateInputIsRequired: "State is required",
        postCodeInputLabel: "Postcode",
        postCodeIsInvalid: "Must be a valid post code",
        postCodeIsRequired: "Postcode is required",
        countryInputLabel: "Country",
        countryInputPlaceholder: "Select your Country",
        countryIsRequired: "Country is required",
        cancel: "Cancel",
        save: "Save"
      },
      accountSettings_EditCompanyName: {
        title: "Edit Name",
        companyNameLabel: "Company Name",
        companyNameIsRequired: "Company name is required",
        save: "Save",
        cancel: "Cancel"
      },
      accountSettings_EditWebsite: {
        title: "Edit Website",
        websiteInputLabel: "Website URL",
        save: "Save",
        cancel: "Cancel"
      },
      accountSettings_EditTimezone: {
        title: "Edit Timezone",
        timezoneInputLabel: "Timezone",
        save: "Save",
        cancel: "Cancel"
      },
      accountSettings_EditCurrency: {
        title: "Edit Currency",
        currencyLabel: "Currency",
        save: "Save",
        cancel: "Cancel"
      },
      privacy: {
        pageTitle: "Security",
        basicSettings: "Basic Settings",
        // emptyStateText:
        //   "This section is unavailable. For more information contact your organization's admin",
        passwordTitle: "Password",
        mfaTitle: "Multi-Factor Authentication",
        // mfaDescription:
        //   'Use multiple authentication steps to increase security for your account',
        mfaRequired: "Required",
        mfaHelpMessage: "Multi-factor authentication is required for at least one organization you are affiliated with.",
        mfaEnabled: "Enabled",
        mfaDisabled: "Disabled"
        // mfaAuthenticatorApp: 'Authenticator App',
        // mfaAddAuthenticatorApp: 'Add Authenticator App',
        // mfaSMS: 'SMS',
        // mfaAddSMS: 'Add SMS',
        // mfaWebAuthnPlatform: 'Built-in Authenticator',
        // mfaWebAuthnPlatformDisabledTooltip:
        //   'To enable a built-in authenticator, you must enable another method first.',
        // mfaSmsDisabledTooltip:
        //   'Before setting up SMS MFA, set up another method first.',
        // mfaAddWebAuthnPlatform: 'Add Built-in Authenticator',
        // mfaWebAuthnCrossPlatform: 'Security Key',
        // mfaAddWebAuthnCrossPlatform: 'Add Security Key',
        // mfaDeleteDevice: 'Delete',
        // mfaDeviceEnabled: 'Enabled',
        // mfaSetup: 'Set up',
        // passkeysTitle: 'Passkeys',
        // passkeysSetUpDescription: 'Passkeys set up - Built-in authenticator',
        // setUpPasskeys: 'Set up passkeys',
        // noPasskeysSetYet: 'No Passkeys set yet',
        // disabledSetUpPasskeysTooltip:
        // 'In order to set up Passkeys, add an Authenticator App or SMS as multi-factor authenticator',
        // smsTitle: 'SMS login',
        // setUpSms: 'Set up SMS login',
        // noPhoneNumberSet: 'No phone number set yet',
        // disabledSetUpSmsTooltip:
        //   'Before setting up SMS login, set up another MFA method',
        // editPhoneNumber: 'Edit phone number',
        // deletePhoneNumber: 'Delete phone number',
      },
      privacy_ChangePassword: {
        title: "Change Password",
        currentPasswordInputLabel: "Current password",
        currentPasswordIsRequired: "Current password is required",
        newPasswordInputLabel: "New password",
        newPasswordIsRequired: "New password is required",
        confirmPasswordInputLabel: "Confirm new password",
        confirmPasswordIsRequired: "Confirm password is required",
        confirmPasswordMustMatch: "Passwords must match",
        changePassword: "Change Password",
        cancel: "Cancel"
      },
      privacy_DisableMfa: {
        title: "Disable multi-factor authentication",
        description: "Disabling multi-factor will remove an extra layer of security.",
        tokenInputLabel: "Enter the generated 6-digit code below",
        tokenInputLabelPlaceholder: "6-digit code",
        codeIsRequired: "Code is required",
        codeLengthAtLeast6: "Min length is 6 characters",
        cancel: "Cancel",
        disable: "Disable"
      },
      // privacy_DisableMfaAuthenticatorApp: {
      //   dialogTitle: 'Delete MFA method',
      //   disableTitle: 'Additional authentication required',
      //   disableDescription:
      //     'To delete this MFA method, additional authentication is required',
      //   cancel: 'Cancel',
      //   disable: 'Delete',
      // },
      // privacy_DisableMfaSms: {
      //   dialogTitle: 'Delete MFA method',
      //   disableTitle: 'Additional authentication required',
      //   disableDescription:
      //     'To delete this MFA method, we sent you a  6-digit code to your phone {{phoneNumber}}',
      //   cancel: 'Cancel',
      //   disable: 'Delete',
      // },
      privacy_EnableMfa: {
        title: "Multi-Factor Authentication",
        subtitle: "Enable MFA to get an extra layer of security.",
        scanDescription1: "Use your phone to scan the following QR code with",
        scanDescription2: "or other authenticator apps.",
        codeInputLabel: "Enter the generated 6-digit code below",
        codeInputPlaceholder: "6-digit code",
        codeIsRequired: "Code is required",
        codeLengthAtLeast6: "Min length is 6 characters",
        recoveryCodeTitle: "Recovery code can be used to disable multi-factor authentication in case you lose your phone.",
        recoveryCodeLabel: "Your recovery code",
        recoveryCodeInstructions: "Copy and save the code, because we won't show it again.",
        cancel: "Cancel",
        verify: "Verify",
        close: "Close"
      },
      // privacy_EnableMfaSms: {
      //   preEnrollTitle: 'Enter phone number',
      //   preEnrollDescription: 'Enter your phone number to get  6-digit code',
      //   phoneIsRequired: 'Phone number is required',
      //   phoneIsInvalid: 'Must be a valid phone number',
      //   enrollTitle: 'Enter the generated 6-digit code below',
      //   enrollDescription:
      //     'To continue, we sent you a  6-digit code to your phone {{phoneNumber}}',
      //   cancel: 'Cancel',
      //   confirm: 'Confirm',
      //   otcResend: 'Resend a new code',
      //   otcResending: 'Sending code...',
      // },
      // privacy_EnableMfaAuthenticatorApp: {
      //   enrollDescription:
      //     'Use your phone to scan the QR code with Google Authenticator or other authenticator apps.',
      //   cancel: 'Cancel',
      //   confirm: 'Confirm',
      // },
      // privacy_UserSessions: {
      //   loginSessionsTitle: 'Login Sessions',
      //   deviceHeader: 'Device',
      //   ipAddressHeader: 'IP Address',
      //   locationHeader: 'Location',
      //   timeHeader: 'Time',
      //   currentSessionChip: 'Current',
      //   impersonatedSessionChip: 'Impersonated',
      //   logout: 'Log out',
      //   logoutAllButtonText: 'Log out all other sessions',
      //   logoutAllDialogAcceptButton: 'Log out all',
      //   logoutAllDialogText:
      //     'You will be logged out of all other active sessions besides this one and will have to log back in.',
      //   logoutAllDialogTitle: 'Log out from other sessions',
      // },
      // privacy_deletePasskeysDialog: {
      //   title: 'Delete passkeys',
      //   description:
      //     'Are you sure you want to delete Passkeys? It will affect your login. After deleting, Passkeys cannot be used on any device.',
      //   cancel: 'Cancel',
      //   delete: 'Delete',
      // },
      // privacy_setUpSmsDialog: {
      //   setUpSmsTitle: 'Set up SMS login',
      //   preVerifySmsDescription:
      //     'To set up SMS login, enter your phone number below',
      //   phoneIsRequired: 'Phone number is required',
      //   phoneIsInvalid: 'Must be a valid phone number',
      //   verifyDescription: 'We just sent a 6-digit code to {{phoneNumber}}.',
      //   cancel: 'Cancel',
      //   confirm: 'Confirm',
      //   continue: 'Continue',
      //   otcResend: 'Resend code',
      //   otcResending: 'Sending code...',
      //   successfullySetUpTitle: 'Successfully added',
      //   successfullySetUpDescription:
      //     'You can now log in with this number instead of your email',
      //   phoneNumber: 'Phone number',
      //   successfullyAddedTitle: 'Successfully added',
      //   successfullyAddedDescription:
      //     'You can now log in with this number instead of your email',
      //   done: 'Done',
      // },
      // privacy_deleteSmsDialog: {
      //   dialogTitle: 'Delete phone number',
      //   deleteSmsFirstDescription:
      //     "By deleting your phone number you won't be able to log in with SMS anymore.",
      //   deleteSmsSecondDescription:
      //     'Enter a 6-digit code we sent to your phone {{phoneNumber}}',
      //   cancel: 'Cancel',
      //   delete: 'Delete',
      // },
      security: {
        // generalSettingsTab: 'General Settings',
        // ipRestrictionTab: 'IP Restrictions',
        // sessionManagementTab: 'Session Management',
        // domainRestrictionTab: 'Domain Restrictions',
        pageTitle: "Security",
        subtitle: "Settings",
        mfaTitle: "MFA",
        mfaPolicyDontForceDescription: "MFA is allowed but not enforced",
        mfaPolicyForceDescription: "All users will be forced to enable MFA",
        mfaPolicyForceExceptSAMLDescription: "All non-SAML users will be forced to enable MFA",
        lockoutTitle: "User Lockout",
        lockoutNotConfigured: "Lockout not configured",
        lockoutEnabledMaxAttempts1: "User is locked after",
        lockoutEnabledMaxAttempts2: "wrong password attempts",
        lockoutDisabled: "Lockout Disabled",
        passwordHistoryTitle: "Password History",
        passwordHistoryNotConfigured: "Password history not configured",
        passwordHistoryEnabledHistorySize1: "Reject passwords that are identical to",
        passwordHistoryEnabledHistorySize2: "recently used password.",
        passwordHistoryDisabled: "Password History Disabled"
        // emptyStateText:
        //   "This section is unavailable. For more information contact your organization's admin",
      },
      security_EditMfaPolicy: {
        title: "MFA Policy",
        dontForceTitle: "Don't Force",
        dontForceDescription: "MFA is allowed but not enforced",
        forceTitle: "Force",
        forceDescription: "All users will be forced to enable MFA",
        forceExceptSAMLTitle: "Force except enterprise SSO",
        forceExceptSAMLDescription: "All non-enterprise SSO users will be forced to enable MFA",
        cancel: "Cancel",
        save: "Save"
      },
      // security_mfaInnerPage: {
      //   title: 'Multi-factor Authentication',
      //   dontForceTitle: "Don't Force",
      //   dontForceDescription: 'MFA is allowed but not enforced',
      //   forceTitle: 'Force',
      //   forceDescription: 'All users will be forced to enable MFA',
      //   forceExceptSAMLTitle: 'Force except enterprise SSO',
      //   forceExceptSAMLDescription:
      //     'All non-enterprise SSO users will be forced to enable MFA',
      //   enrolledUsers: 'Enrolled users',
      //   users: 'users',
      //   usersWithoutMfa: 'Users without MFA',
      //   searchUserPlaceholder: 'Search for any text...',
      //   noUsersText: 'No users without MFA',
      //   noResultsFoundText: 'No results found',
      //   noResultsFoundDescription:
      //     "It seems we can't find any results based on your search.",
      //   rolesColumn: 'Roles',
      //   usersColumn: 'Users',
      // },
      security_EditLockoutPolicy: {
        title: "User Lockout Policy",
        attemptsInputLabel: "Maximum invalid login attempts",
        attemptsInputPlaceholder: "Ex. after 5 wrong password attempts",
        attemptsInputErrorMessage: "Must be a positive number",
        cancel: "Cancel",
        save: "Save"
      },
      security_EditPasswordHistoryPolicy: {
        title: "Password History Policy",
        sizeInputLabel: "History Size",
        sizeInputPlaceholder: "",
        sizeIsRequired: "History size is required",
        sizeMustBeNumber: "Must be a positive number",
        sizeMustBeGt0: "Must be greater than or equal to 0",
        sizeMustBelt10: "Must be less than or equal to 10",
        cancel: "Cancel",
        save: "Save"
      },
      // security_SessionManagement: {
      //   sectionTitle: 'Session Management',
      //   idleSessionTimeoutTitle: 'Idle Session Timeout',
      //   idleSessionTimeoutDescription:
      //     'Define how long user sessions can be idle before they are ended.',
      //   idleSessionTimeoutErrorMessage:
      //     'Minimum idle session timeout is 5 minutes',
      //   sessionTimeoutTitle: 'Force Re-login',
      //   sessionTimeoutDescription:
      //     'Force users to log in again if their session (whether active or inactive) reaches this time limit.',
      //   sessionTimeoutErrorMessage: 'Minimum timeout is 1 day',
      //   maxSessionTimeoutErrorMessage: 'Maximum timeout is 5 years',
      //   maxIdleSessionTimeoutErrorMessage: 'Maximum timeout is 24 days',
      //   concurrentSessionsTitle: 'Maximum Concurrent Sessions',
      //   concurrentSessionsDescription:
      //     'Set the maximum sessions a user can have open at the same time. New sessions will automatically log out their oldest session.',
      //   concurrentSessionsTimeoutErrorMessage:
      //     'Minimum concurrent sessions is 1',
      //   maxConcurrentSessionsTimeoutErrorMessage:
      //     'Maximum concurrent sessions is 100',
      //   day: 'day',
      //   days: 'days',
      //   hour: 'hour',
      //   hours: 'hours',
      //   minute: 'minute',
      //   minutes: 'minutes',
      //   saveButton: 'Save',
      //   emptyStateText:
      //     "This section is unavailable. For more information contact your organization's admin",
      //   sessionsTitle: 'Sessions',
      // },
      // security_DomainRestrictions: {
      //   allowButton: 'Allow only',
      //   denyButton: 'Deny only',
      //   emailDomainRestrictionTitle: 'Domain Restrictions',
      //   emailDomainRestrictionDescription:
      //     "Only users with approved email domains can be invited to or join your account. Adding domains won't affect existing users. ",
      //   blockPublicDomains: 'Block all public domain emails',
      //   blockPublicDomainsDescription:
      //     'Blocking all public domain emails involves preventing emails from public domain providers, such as Gmail or Yahoo',
      //   addDomainPlaceholder: 'Add new domain',
      //   selectPlaceholder: 'example.com',
      //   invalidDomainError: 'Please enter a valid domain',
      //   sameDomainError: "Sorry, your own domain can't be in the denylist",
      //   uniqueDomainError: 'That domain is already on the list',
      //   changeRestrictionStrategyDialogCancelButton: 'Cancel',
      //   changeRestrictionStrategyDialogConfirmButton: 'Confirm',
      //   changeRestrictionStrategyDialogMessageAllow:
      //     'Are you sure you want to change your email domain restrictions from deny to allow? This will disable the deny rules',
      //   changeRestrictionStrategyDialogTitleAllow:
      //     'Change from deny to allow domains',
      //   changeRestrictionStrategyDialogMessageDeny:
      //     'Are you sure you want to change your email domain restrictions from deny to allow? This will disable the deny rules',
      //   changeRestrictionStrategyDialogTitleDeny:
      //     'Change from allow to deny domains',
      //   noDomainsBeingBlockedAlert:
      //     'There are currently no domains being blocked',
      //   emptyStateText:
      //     "This section is unavailable. For more information contact your organization's admin",
      //   addDomainsTitle: 'Domains',
      // },
      // security_SessionManagementDialog: {
      //   title: 'Session Management',
      //   description:
      //     'By applying these settings, your current session will end. Would you like to save them and be logged out?',
      //   cancel: 'Cancel',
      //   confirm: 'Confirm',
      // },
      // security_ipRestrictions: {
      //   addButton: 'Add',
      //   allowButton: 'Allow only',
      //   denyButton: 'Deny only',
      //   deleteButton: 'Delete',
      //   deleteAction: 'Delete',
      //   editAction: 'Edit',
      //   editButton: 'Edit',
      //   myCurrentIp: 'My Current IP',
      //   ownIpDisclaimerAllow:
      //     'Your IP is {{ip}}. It must be added and activated before you can activate other IPs.',
      //   currentIpChip: 'My Current IP',
      //   title: 'IP Address Restriction',
      //   subTitle:
      //     'When activated, users with IP addresses activated below will be either allowed or denied when they try to log in to this account. You can use IPv4, IPv6, and masks in CIDR notation.',
      //   tableIpAddress: 'IP Address',
      //   tableIpDescription: 'IP Description',
      //   addIpAddressPlaceholder: 'Add IP Address',
      //   addIpDescriptionPlaceholder: 'Add IP Description',
      //   ipAddressRequiredMessage: 'IP address is required',
      //   ipAddressInvalidMessage: 'IP is not valid',
      //   ipAddressUniqueMessage: 'IP must be unique',
      //   ipAddressSameMessage: "Denylists can't include your own IP",
      //   ipDescriptionRequiredMessage: 'IP description is required',
      //   deleteIpDialogTitle: 'Delete IP',
      //   deleteIpDialogMessage: 'Are you sure you want to delete',
      //   deleteCidrDialogMessageAfterMessage: "and it's IP addresses",
      //   deleteIpDialogCancelButton: 'Cancel',
      //   deleteIpDialogDeleteButton: 'Delete',
      //   changeRestrictionStrategyDialogCancelButton: 'Cancel',
      //   changeRestrictionStrategyDialogDeleteButton: 'Change',
      //   changeRestrictionStrategyDialogMessageAllow:
      //     'Are you sure you want to change your IP restrictions from Deny to Allow?nThis will change the default rule from denying all IPs to allowing all IPs',
      //   changeRestrictionStrategyDialogMessageDeny:
      //     'Are you sure you want to change your IP restrictions from Allow to Deny?nThis will change the default rule from denying all IPs to allowing all IPs',
      //   changeRestrictionStrategyDialogTitleDeny: 'Change the list to deny IP',
      //   changeRestrictionStrategyDialogTitleAllow:
      //     'Change the list to allow IP',
      //   addMyIp: 'Add my IP',
      //   AddMyIpDialogCancelButton: 'Cancel',
      //   AddMyIpDialogConfirmButton: 'Add my IP',
      //   AddMyIpDialogMessage:
      //     'Your IP must be added and activated before you can activate other IPs. Confirm in order to add your IP and activate IP restrictions',
      //   AddMyIpDialogTitle: 'Add my IP',
      //   emptyStateText:
      //     "This section is unavailable. For more information contact your organization's admin",
      //   ipRestrictionsTableTitle: '{{strategy}} only list',
      // },
      // securityCenter_recommendations: {
      //   forceMfaTitle: 'Force MFA for all users',
      //   forceMfaDescription:
      //     'MFA is the best security measure you can take. By forcing MFA, all users in your account will be required to set up MFA on their next login.',
      //   forceMfaButtonText: 'Manage',
      //   breachedPasswordExistsTitle:
      //     '{{breachedPasswordUsersCount}}/{{totalUsers}} of your users have breached passwords',
      //   breachedPasswordExistsDescription:
      //     'Send them a reminder to change their passwords',
      //   breachedPasswordExistsButtonText: 'Send reset password email',
      //   breachedPasswordButtonTooltip:
      //     'Send reset password email will be available again in {{daysRemaining}} days',
      //   enableUserLockoutTitle: 'Enable user lockout',
      //   enableUserLockoutDescription:
      //     'User lockout helps keep bad actors out when they try too many incorrect passwords',
      //   enableUserLockoutButtonText: 'Manage',
      //   strengthenUserLockoutTitle: 'Strengthen your user lockout policy',
      //   strengthenUserLockoutDescription:
      //     'We recommend decreasing your user lockout policy to {{userLockoutRecommendation}} or less',
      //   strengthenUserLockoutButtonText: 'Manage',
      //   enablePasswordHistoryTitle: 'Enable password history',
      //   enablePasswordHistoryDescription:
      //     'Password history helps keep passwords fresh and makes it less likely for passwords to become breached',
      //   enablePasswordHistoryButtonText: 'Manage',
      //   strengthenPasswordHistoryTitle:
      //     'Strengthen your password history policy',
      //   strengthenPasswordHistoryDescription:
      //     'We recommend decreasing your password history policy to {{historyRecommendations}} or less',
      //   strengthenPasswordHistoryButtonText: 'Manage',
      //   enableForceReloginTitle: 'Enable force relogin',
      //   enableForceReloginDescription:
      //     "Setting a force relogin policy ensures user sessions don't last too long and risk becoming compromised",
      //   enableForceReloginButtonText: 'Manage',
      //   setForceReloginTitle:
      //     'Set force relogin to {{forceReloginRecommendation}} {{forceReloginTimeFormat}}',
      //   setForceReloginDescription:
      //     'We recommend setting your force relogin policy to {{forceReloginRecommendation}} {{forceReloginTimeFormat}} or less',
      //   setForceReloginButtonText: 'Manage',
      //   enableSessionConcurrencyTitle: 'Enable max concurrent sessions',
      //   enableSessionConcurrencyDescription:
      //     "Max concurrent sessions ensures users don't open too many sessions, which can be unsafe",
      //   enableSessionConcurrencyButtonText: 'Manage',
      //   setSessionConcurrencyTitle:
      //     'Set max concurrent sessions to {{concurrencyRecommendation}}',
      //   setSessionConcurrencyDescription:
      //     'We recommend setting your max concurrent sessions policy to {{concurrencyRecommendation}} or less',
      //   setSessionConcurrencyButtonText: 'Manage',
      //   enableIdleSessionTitle: 'Enable idle session',
      //   enableIdleSessionDescription:
      //     "Idle session timeout ensures idle sessions don't become targets for attack",
      //   enableIdleSessionButtonText: 'Manage',
      //   setIdleSessionTitle:
      //     'Set idle session to {{idleTimeoutRecommendation}} {{idleTimeoutTimeFormat}}',
      //   setIdleSessionDescription:
      //     'We recommend setting your idle session policy to {{idleTimeoutRecommendation}} {{idleTimeoutTimeFormat}} or less',
      //   setIdleSessionButtonText: 'Manage',
      //   enableIpRestrictionsTitle: 'Enable IP restrictions',
      //   enableIpRestrictionsDescription:
      //     'IP restrictions let you tightly control which IP addresses can access your account',
      //   enableIpRestrictionsButtonText: 'Manage',
      //   changeIpToAllowListTitle: 'Change IP restrictions to allowlist',
      //   changeIpToAllowListDescription:
      //     'An IP allowlist excludes all other IPs and is therefore stronger than an IP denylist',
      //   changeIpToAllowListButtonText: 'Manage',
      //   enableDomainRestrictionsTitle: 'Enable domain restrictions',
      //   enableDomainRestrictionsDescription:
      //     'Domain restrictions make sure only users with certain domains can access your account',
      //   enableDomainRestrictionsButtonText: 'Manage',
      //   changeDomainToAllowListTitle: 'Change domain restrictions to allowlist',
      //   changeDomainToAllowListDescription:
      //     'A domain allowlist excludes all other domains and is therefore stronger than a domain denylist',
      //   changeDomainToAllowListButtonText: 'Manage',
      //   removeStaleUsersTitle:
      //     'You currently have {{staleUsersCount}} inactive users in your account',
      //   removeStaleUsersDescription:
      //     'Inactive users should be removed to help protect your account',
      //   removeStaleUsersButtonText: 'Manage',
      //   configureSSOTitle: 'SSO can improve security',
      //   configureSSODescription:
      //     'Set up SSO now and enjoy simplified access and boosted security',
      //   configureSSOButtonText: 'Manage',
      //   emptyStateForRecommendationsTitle: "You're all set!",
      //   emptyStateForRecommendationsDescription:
      //     'No recommended actions for now',
      //   yourAccountIs: 'Your account is {{levelOfScore}}',
      //   yourAccountSecurityIs: 'Your account security is {{levelOfScore}}',
      //   scoreDescriptionToImproveScore:
      //     'Follow these {{numberOfActions}} recommendations to improve your score',
      //   scoreDescriptionWhenAllSet: "You're all set!",
      // },
      // securityCenter_insights: {
      //   mfaForcedText: 'All your users are forced to log in with MFA',
      //   partiallyForcedMfaText:
      //     'All your users are forced to log in with MFA or use SSO',
      //   partialMfaUsageText:
      //     "{{notEnrolledUsers}}/{{totalUsers}} users don't use MFA",
      //   fullMfaUsageText: 'All your users are enrolled in MFA',
      //   breachedPasswordUsersExistText:
      //     '{{breachedPasswordUsersCount}} of your users have breached passwords',
      //   fullPasswordSettingsText: 'All your password settings are secure',
      //   improveLockoutPolicyText:
      //     'Your user lockout policy could use some improvement',
      //   improvePasswordHistoryPolicyText:
      //     'Your password history policy could use some improvement',
      //   noSessionSettingsText:
      //     'None of your session management settings are configured',
      //   partialSessionsSettingsText:
      //     '{{configuredSessionSettings}}/3 session management settings configured',
      //   fullSessionSettingsText: 'All your session settings are strong',
      //   staleUsersExistText:
      //     'You have {{staleUsersCount}} stale users in your app',
      //   noStaleUsersExistText: 'Nice, you have no stale users in your app!',
      //   noIpRestrictionsText: 'All IPs are allowed',
      //   ipAllowListText: 'Allowing certain IPs',
      //   ipDenyListText: 'Denying certain IPs',
      //   noDomainRestrictionsText: 'All domains are allowed',
      //   domainAllowListText: 'Allowing certain domains',
      //   domainDenyListText: 'Denying certain domains',
      //   mfaCardTitle: 'MFA',
      //   mfaCardButtonText: 'Manage',
      //   passwordCardTitle: 'Password',
      //   passwordCardButtonText: 'Manage',
      //   sessionsCardTitle: 'Sessions',
      //   sessionsCardButtonText: 'Manage',
      //   inactivityCardTitle: 'Inactivity',
      //   inactivityCardButtonText: 'Manage',
      //   inactivityCardDescription:
      //     "See which users haven't been active in a while",
      //   restrictionsCardTitle: 'Restrictions',
      //   restrictionsCardButtonText: 'Manage',
      // },
      // securityCenter_mainPage: {
      //   pageTitle: 'Back to Security',
      //   recommendedActions: 'Recommended actions',
      //   configurations: 'Configurations',
      //   showLessButtonText: 'Hide',
      //   shoeMoreButtonText: 'Show {{numOfItems}} more',
      //   securityCheckUp: 'Security check up',
      // },
      // securityCenter_restrictionsInnerPage: {
      //   restrictions: 'Restrictions',
      //   ips: 'IP',
      //   domain: 'Domain',
      // },
      // security_PasswordInnerPage: {
      //   title: 'Password',
      //   userLockoutTitle: 'User lockout',
      //   userLockoutDescription:
      //     'Set the maximum number of wrong password attempts before a user gets locked',
      //   passwordHistoryTitle: 'Password history',
      //   passwordHistoryDescription:
      //     'Set the number of fresh passwords a user must set before re-using an old one',
      //   userLockoutValidation: 'Value must be greater than 1',
      //   passwordHistoryValidation: 'Value must be greater than 1',
      //   save: 'Save',
      //   usersWithBreachedPasswords: 'Users with breached passwords',
      //   searchUserPlaceholder: 'Search for any text...',
      //   noUsersText: 'No users with breached passwords',
      //   noResultsFoundText: 'No results found',
      //   noResultsFoundDescription:
      //     "It seems we can't find any results based on your search",
      //   rolesColumn: 'Roles',
      //   usersColumn: 'Users',
      //   sendResetPasswordEmail: 'Send reset password email',
      //   sendResetEmailDescription:
      //     'Are you sure you want to send a reset password email to',
      //   cancel: 'Cancel',
      //   send: 'Send',
      //   resetEmailSentSuccessfully: 'Reset password email sent successfully',
      //   disabledSendResetEmailTooltip:
      //     'Send reset password email will be available again in {{daysRemaining}} days',
      //   resetPasswordEmailSentSuccessfully:
      //     'Reset password email sent successfully',
      //   continue: 'Continue',
      // },
      // securityCenter_InnerPages: {
      //   summary: 'Summary',
      //   configuration: 'Configuration',
      // },
      // securityCenter_InactivityInnerPage: {
      //   inactivity: 'Inactivity',
      //   searchUserPlaceholder: 'Search for any text...',
      //   noUsersText: 'No inactive users ',
      //   noResultsFoundText: 'No results found',
      //   noResultsFoundDescription:
      //     "It seems we can't find any results based on your search",
      //   rolesColumn: 'Roles',
      //   usersColumn: 'Users',
      //   inactiveUsers: '{{inactiveUsersCount}} inactive users',
      //   lastSeenHeader: 'Last activity',
      //   deleteUser: 'Delete user',
      //   deleteUserDescriptionPart1: 'Are you sure you want to delete ',
      //   deleteUserDescriptionPart2: '?',
      //   cancel: 'Cancel',
      //   delete: 'Delete',
      //   overDays: 'over {{numberOfDays}} days ago',
      //   lastActivity: 'Last Active',
      // },
      roles: {
        pageTitle: "Roles & Permissions",
        actionsHeader: "Actions",
        addNewRoleButton: "Add Role",
        searchInputPlaceholder: "Search for any text...",
        searchingPlaceholder: "Searching roles...",
        noRolesYet: "You didn't add nroles yet",
        noRolesYetDescription: "Add new roles to see the results in your table",
        noResultFound: "No Result found",
        noResultFoundDescription: "It seems we can't find any results based on your search."
      },
      roles_AddRole: {
        title: "Add New Role",
        nameInputLabel: "Role name",
        nameIsRequired: "Role name is required",
        keyInputLabel: "Role key",
        keyIsRequired: "Role key is required",
        descriptionInputLabel: "Role description",
        inheritPermissionInputLabel: "Default role to inherit permissions from:",
        inheritPermissionInputPlaceholder: "Select role",
        cancel: "Cancel",
        create: "Create"
      },
      sso: {
        pageTitle: "Single Sign On",
        // ssoTab: 'Single Sign On',
        enableAlert: "Please notice, you must configure all SSO steps before you enable it.",
        subtitle: "Configuration",
        stepOneTitle: "Configure Your IDP",
        stepOne: "Step 1",
        stepTwoTitle: "Claim Domain",
        stepTwo: "Step 2",
        stepThreeTitle: "Manage Authorization",
        stepThree: "Step 3",
        enableTitle: "Enable Single Sign On",
        switchProviderAlert: "{{provider}} authentication is not supported anymore."
        // dialogTitle: 'Setup SSO connection',
      },
      sso_Header: {
        title: "SSO Connections",
        addNew: "Add New"
        // setupSsoConnection: 'Setup SSO connection',
      },
      sso_Table: {
        editSSOConfig: "Edit",
        deleteSSOConfig: "Delete",
        areYouSureDeleteSSOConfig: "Are you sure you want to delete this sso connection? you won't be able to undo this process",
        deleteSSOConfigTitle: "Delete SSO Connection?",
        noSSOConfigsYet: "You haven't configured SSO yet",
        noSSOConfigsYetDescription: "Add new sso connection to see the results in your table",
        cancel: "Cancel",
        back: "Back",
        done: "Done",
        proceed: "Proceed",
        skip: "Skip",
        rolesColumnName: "Roles",
        domainsColumnName: "Domains",
        idpColumnName: "IDP",
        statusColumnName: "Status"
      },
      sso_ClaimDomain: {
        claimDomainText: "Copy this info into a new TXT record in your DNS file:",
        title: "Step 1 - Claim Domain",
        domainInputLabel: "Domain Name",
        domainInputPlaceholder: "Enter SSO domain",
        domainIsRequired: "Domain name is required",
        domainMustBeValid: "Must be a valid domain",
        domainValidatedMessage: "Domain Validated",
        recordNameLabel: "Record Name",
        recordValueLabel: "Record Value",
        validate: "Validate",
        proceed: "Proceed",
        save: "Save",
        close: "Close",
        next: "Next",
        saveAndEnable: "Save and enable SSO",
        cancel: "Cancel"
      },
      sso_ConfigureIdp: {
        title: "Step 2 - Configure Your IDP",
        enabled: "Enabled",
        successfullyEnabledMessage: "Single Sign on is",
        successfullyIdpConfigured: "IDP Configured",
        radioAutomaticLabel: "AUTOMATIC",
        radioManualLabel: "MANUAL",
        metadataFileLabel: "Metadata File",
        // metadataFileLabelGuides: 'XML Metadata File',
        metadataFileDescription: "XML file with your configurations",
        metadataFileTypeErrorMessage: "This file type is invalid. Please insert an xml",
        metadataFileIsRequired: "Metadata file is required",
        // metadataUrlIsRequired: 'Metadata url is required',
        // metadataUrlIsInvalid: 'Metadata url most be valid URL',
        idpSelectLabel: "Select your connection type",
        acsUrlInputLabel: "ACS URL",
        entityIdInputLabel: "Entity ID",
        endpointInputLabel: "SSO Endpoint",
        endpointInputPlaceholder: "Url from the SSO",
        endpointIsRequired: "Endpoint is required",
        endpointUrlIsInvalid: "Endpoint must be valid URL",
        issuerUrlInputLabel: "Issuer URL",
        issuerUrlIsRequired: "Issuer url is required",
        issuerUrlIsInvalid: "Issuer url must be valid URL",
        issuerUrlInputHelpMessage: "The Open ID Connect '93well known'94 url provided by the IDP",
        ssoWellKnownError: "We couldn't verify your issuer URL",
        publicCertificateInputLabel: "Public Certificate",
        publicCertificateInputPlaceholder: "Provide Public Certificate",
        publicCertificateIsRequired: "Public certificate is required",
        clientIdInputLabel: "Client Id",
        clientIdInputPlaceholder: "Client Id",
        clientIdIsRequired: "Client id is required",
        secretInputLabel: "Secret Key",
        secretInputPlaceholder: "Secret Key",
        secretIsRequired: "Secret key is required",
        redirectUriInputLabel: "Redirect URI",
        validate: "Validate",
        proceed: "Proceed",
        save: "Save",
        close: "Close",
        next: "Next",
        // back: 'Back',
        saveAndEnable: "Save and enable SSO",
        cancel: "Cancel"
        // backToSSO: 'Back to setup SSO connection',
        // columnName: 'Name',
        // columnValue: 'Value',
        // idpUrlLabel: 'IdP Metadata URL',
        // configureAutomatically: 'Configure Automatically',
        // configureManually: 'Configure Manually',
        // chooseIdpGuide:
        // 'Select your IDP guide to help you do the process quickly and easy',
        // chooseIdpGuideNotCompleted:
        //   'The configuration of SSO is not complete. Check that all steps have been completed in the IDP guide',
        // confirmationStep: 'Confirmation',
        // confirmationStepCompleteTitle: 'IDP configuration is completed',
        // confirmationStepCompleteDescription:
        //   "By clicking on 'Continue to claim domain', I confirm I've completed the configure your IDP form.",
        // confirmationStepCompleteButton: 'Continue to claim domain',
        // confirmationStepFailedTitle: 'SSO configuration unsuccessful',
        // confirmationStepFailedDescription:
        //   "We can't identify the cause of the problem. Make sure that all steps are followed.",
        // retry: 'Retry',
        // tryAgain: 'Try again',
      },
      sso_ManageAuthorization: {
        title: "Step 3 - Manage Authorization",
        enabled: "Enabled",
        rolesIsRequired: "At least one role is required",
        selectRolesLabel: "Default SSO roles",
        rolesInputLabel: "Roles",
        rolesInputPlaceholder: "Select Role",
        selectRolesHelpMessage: "These roles will be assigned by default to users who sign up via SSO",
        successfullyAuthorizationManaged: "",
        successfullyEnabledMessage: "Single Sign on is",
        addMapping: "Add mapping",
        group: "Group",
        roles: "Roles",
        rolesGroupsMappingTitle: "Roles Groups Mapping",
        rolesGroupsMappingDescription: "Automatically assign additional roles according to your identity provider groups",
        rolesGroupsMappingError: "Group must have at least 1 role",
        rolesGroupsNameEmptyError: "Group name cannot be empty",
        rolesGroupsNameDuplicateError: "Group name must be unique",
        ssoAddMapping: "Add mapping",
        validate: "Validate",
        proceed: "Proceed",
        save: "Save",
        close: "Close",
        next: "Next",
        saveAndEnable: "Save and enable SSO",
        cancel: "Cancel"
      },
      users: {
        pageTitle: "Users",
        inviteUserButton: "Invite User",
        searchInputPlaceholder: "Search for any text...",
        searchingPlaceholder: "Searching...",
        meTooltip: "Me",
        userHeader: "User",
        rolesHeader: "Roles",
        // groupsHeader: 'Groups',
        organizationHeader: "Organization",
        joinedHeader: "Joined",
        // managedByHeader: 'Managed By',
        lastSeenHeader: "Last Seen",
        editRolesAction: "Edit roles",
        pendingApprovalStatus: "Pending approval",
        pendingActivationStatus: "Not activated",
        resendInvitationAction: "Resend invitation email",
        resendActivationAction: "Resend activation email",
        // logOutUserSessionsActions: 'Log out user sessions',
        leaveTeamAction: "Leave Team",
        deleteUserAction: "Delete User",
        noUsersYet: "You didn't add nusers yet",
        noUsersYetDescription: "Add new users to see the results in your table",
        noResultFound: "No Result found",
        noResultFoundDescription: "It seems we can't find any results based on your search."
        // externallyManaged: 'Managed externally',
        // assignedByGroups: 'Assigned by groups',
        // assignedByGroupsAndDefault: 'Default and assigned by groups',
      },
      users_DeleteUser: {
        title: "Delete User",
        areYouSureDeleteUser1: "Are you sure you want to delete",
        areYouSureDeleteUser2: "you won't be able to undo this process.",
        cancel: "Cancel",
        delete: "Delete"
      },
      users_EditUserRoles: {
        title: "Edit Roles",
        selectRolesLabel: "Default roles",
        // selectRolesTooltip:
        // 'This user will always have these roles, regardless of groups they belong to.',
        // rolesFromGroupsLabel: 'Roles from groups',
        // rolesFromGroupsRolesColumnLabel: 'Roles',
        // rolesFromGroupsGroupsColumnLabel: 'Groups',
        selectRolesPlaceholder: "Select default roles for user",
        // alsoAssignedByGroups: 'Also assigned by groups',
        cancel: "Cancel",
        update: "Update"
      },
      users_InviteUser: {
        title: "Invite User",
        inviteWithLinkSettings: "Invite with link settings",
        firstNameInputLabel: "First Name",
        // fullNameInputLabel: 'Full Name',
        firstNameIsRequired: "First name is required",
        // fullNameIsRequired: 'Name is required',
        lastNameInputLabel: "Last Name",
        lastNameIsRequired: "Last name is required",
        emailInputLabel: "Email & Role",
        // emailInputLabelWithoutRoles: 'Email',
        emailIsRequired: "Email is required",
        emailMustBeValid: "Must be a valid email",
        phoneInputLabel: "Phone Number",
        phoneIsRequired: "Phone number is required",
        phoneIsInvalid: "Must be a valid phone number",
        rolesInputLabel: "Roles",
        rolesIsRequired: "At least one role is required",
        rolesInputPlaceholder: "Select roles",
        cancel: "Cancel",
        invite: "Invite"
        // selectRole: 'Select role',
        // multipleRoles: 'Multiple roles',
        // bulkLabel: 'Email & Role',
        // bulkLabelWithoutRoles: 'Email',
        // bulkPlaceHolder: 'Type email address and press "Enter"',
        // bulkFormHelper: 'You can invite up to 5 users at a time.',
        // bulkDomainsError:
        //   "Sorry, you can't invite users with this domain due to your organization's restrictions.",
        // uniqueEmailError:
        //   'This email already exists, please provide a unique address',
        // invitationSuccessfully: 'invitations sent successfully',
        // userAlreadyExistsPart1: 'Not sent to',
        // userAlreadyExistsPart2: 'because they already exist',
      },
      users_EditInvitationLink: {
        title: "Invite with link settings",
        inviteWithLinkTitle: "Invite with link",
        expirationInputLabel: "Expiration",
        expirationInputPlaceholder: "Please select an option",
        linkExpiration: "Link will be expired in {{days}}",
        sendMeNotification: "Send me an email each time someone joins using this invitation link",
        notification: "Notification",
        deactivateLink: "Deactivate link",
        back: "Back",
        save: "Save",
        copyInviteLink: "Copy invite link",
        day: "day",
        days: "days",
        edit: "Edit"
      },
      users_DeactivateInvitationLink: {
        title: "Deactivate link",
        areYouSureDeleteInviteLink: "Are you sure you want to deactivate invite link?",
        cancel: "Cancel",
        deactivate: "Deactivate"
      },
      // groups: {
      //   pageTitle: 'Groups',
      //   addNewGroup: 'Add new group',
      //   search: 'Search by group name or description',
      //   noGroupsMessage: 'No groups yet',
      //   noGroupsFoundMessage: 'No groups found',
      // },
      // usersGroups_addOrEditGroupDialog: {
      //   titleCreate: 'Add new group',
      //   titleAddMembers: 'Add users to group',
      //   titleEdit: 'Edit group',
      //   groupName: 'Group name',
      //   groupDescription: 'Description (optional)',
      //   groupColor: 'Group color',
      //   assignRoles: 'Group roles (optional)',
      //   assignRolesPlaceholder: 'Select group roles',
      //   groupDetails: 'Group details',
      //   addMembers: 'Add members',
      //   searchByEmailOrName: 'Search by email or name',
      //   noUsersFound: 'No users found',
      //   selectColor: 'Group color',
      //   next: 'Next',
      //   create: 'Create',
      //   add: 'Add',
      //   cancel: 'Cancel',
      //   save: 'Save',
      //   assignRolesTooltip:
      //     'Group members will get these roles in addition to the roles they already have.',
      //   groupNameAlreadyExists:
      //     'Group name already taken. Please choose another.',
      //   groupNameRequired: 'Group name is required',
      // },
      // userGroups_usersTable: {
      //   members: 'Members',
      //   joinedGroup: 'Joined group',
      //   activated: 'Activated',
      //   addUser: 'Add user',
      //   searchByEmailOrName: 'Search by email or name',
      //   noResultsMessage: 'No results found',
      //   noMembersMessage: 'No group members yet',
      //   meTooltip: 'Me',
      //   noMembersDescription:
      //     'You can add members to the group by clicking the "Add user" button.',
      //   searchingPlaceholder: 'Searching...',
      //   search: 'Search for any text...',
      //   pendingStatus: 'Pending...',
      //   removeMemberAction: 'Remove member',
      //   leaveGroupAction: 'Leave group',
      // },
      // usersGroups_card: {
      //   roles: 'Roles',
      //   secret: 'Secret',
      //   editGroup: 'Edit group',
      //   deleteGroup: 'Delete group',
      //   noMembersMessage: 'No group members',
      //   emptyRolesMessage: 'None',
      // },
      // usersGroups_details: {
      //   edit: 'Edit group',
      //   delete: 'Delete group',
      //   pageTitle: 'Back to all groups',
      //   roles: 'Roles',
      //   emptyRolesMessage: 'None',
      //   okta: 'Okta',
      // },
      // usersGroups_deleteGroupDialog: {
      //   title: 'Delete group - ',
      //   description:
      //     'Are you sure you want to delete the group {{name}}?nMembers may lose roles granted by this group.',
      //   delete: 'Delete',
      //   cancel: 'Cancel',
      // },
      // usersGroups_deleteMemberDialog: {
      //   title: 'Remove',
      //   description:
      //     'Are you sure you want to remove {{name}} from {{groupName}} group?nThey may lose roles granted by this group.',
      //   remove: 'Remove',
      //   cancel: 'Cancel',
      // },
      webhooks: {
        pageTitle: "Webhooks",
        searchInputPlaceholder: "Search for any text...",
        addWebhook: "Add Webhook",
        searchingPlaceholder: "Webhook searching...",
        noResultFound: "No Result found",
        noResultFoundDescription: "It seems we can't find any results based on your search.",
        noWebhooksYet: "You haven't created any webhooks yet",
        noWebhooksYetDescription: "Add new webhooks to see the results in your table",
        editWebhook: "Edit webhook",
        deleteWebhook: "Delete webhook",
        nameHeader: "Name",
        statusHeader: "Status"
      },
      webhooks_AddEditWebhook: {
        addTitle: "Add New Webhook",
        editTitle: "Edit Webhook",
        nameInputLabel: "Name",
        nameInputPlaceholder: "Enter webhook name",
        nameIsRequired: "Webhook name is required",
        urlInputLabel: "URL",
        urlInputPlaceholder: "https://",
        urlIsRequired: "Webhook url is required",
        urlIsInvalid: "Must be valid URL",
        secretKeyInputLabel: "Secret Key",
        secretKeyInputPlaceholder: "Enter secret key",
        secretKeyLengthAtLeast8: "Min length is 8 characters",
        eventsInputLabel: "Events",
        eventsInputPlaceholder: "Select events",
        eventsIsRequired: "At least one event is required",
        cancel: "Cancel",
        create: "Create",
        edit: "Update"
      },
      webhooks_DeleteWebhook: {
        title: "Delete Webhook?",
        areYouSureDeleteWebhook1: "Do you really want to delete ",
        areYouSureDeleteWebhook2: "webhook? if you delete it you won't be able to undo the process.",
        cancel: "Cancel",
        delete: "Delete"
      },
      subscriptions: {
        pageTitle: "Subscription",
        externallyManaged: "Your plan is managed by an external contract, contact us to change it",
        currentPlan: "Current Plan",
        selectedPlan: "Selected Plan",
        pricingLink: "Pricing",
        paymentMethodTitle: "Payment Method",
        invoices: "Invoices",
        downloadPdf: "Download PDF",
        cancel: "Cancel",
        confirm: "Confirm",
        update: "Update",
        // continueToPayment: 'Continue to payment',
        updatePaymentMethod: "Update payment method",
        dialogCheckoutTitle: "Checkout",
        dialogSelectionTitle: "Update your plan",
        dialogUpdateBillingDetailsTitle: "Update billing information",
        dialogCancellationTitle: "Cancel Plan",
        dialogRenewalTitle: "Renew Plan",
        expires: "Expires",
        noBillingDetails: "No billing information set",
        setupBillingDetails: "Setup billing information",
        emailInputLabel: "Email",
        emailInputPlaceholder: "name@email.com",
        emailIsRequired: "Email is required",
        emailMustBeValid: "Must be a valid email",
        address1InputLabel: "Address 1",
        address1InputPlaceholder: "Address 1",
        address1IsRequired: "Address 1 is required",
        address2InputLabel: "Address 2",
        address2InputPlaceholder: "address 2",
        address2IsRequired: "Address 2 is required",
        cityInputLabel: "City",
        cityInputPlaceholder: "City",
        cityIsRequired: "City is required",
        stateInputLabel: "State",
        stateInputPlaceholder: "State",
        stateInputIsRequired: "State is required",
        postCodeInputLabel: "Postcode",
        postCodeInputPlaceholder: "Postal Code",
        postCodeIsInvalid: "Must be a valid post code",
        postCodeIsRequired: "Postcode is required",
        countryInputLabel: "Country",
        countryInputPlaceholder: "Country",
        countryIsRequired: "Country is required"
      },
      subscriptions_CurrentPlan: {
        title: "Current Plan",
        priceSubtitle: "{{price}} per month",
        yourPlanWillBeCanceled: "Your plan will be canceled on {{periodEnd}}",
        yourPlanWillBeRenewed: "Your plan renews on {{periodEnd}}",
        yourPlanIsTrialing: "Your trial ends on {{periodEnd}}",
        renewalDefault: "Unknown renewal date",
        canceled: "Canceled",
        trialing: "On Trial",
        trialEnded: "Trial Ended",
        cancelButton: "Cancel Plan",
        renewButton: "Renew Plan",
        updateButton: "Update Plan",
        buyNowButton: "Buy Now",
        unknownPlan: "Unknown Plan"
      },
      subscriptions_DialogSelection: {
        title: "Update your plan",
        currentPlan: "Current Plan",
        continue: "Continue",
        selectPlanPricePerRecurringInterval: "{{currency}}{{price}} per {{interval}}"
      },
      subscriptions_Billing: {
        title: "Update Billing Information",
        intervalTitle: "per each {{interval}}",
        intervalMonth: "month",
        intervalYear: "year",
        unknownDate: "unknown date",
        unknown: "Billing Unstated",
        monthly: "Billed Monthly",
        paymentMethod: "PAYMENT METHOD",
        // billingAddress: 'BILLING ADDRESS',
        confirmError: "Unable to process payment method: {{error}}",
        invalidCardStatusError: "Invalid card status: {{status}}",
        confirmGenericError: "Unable to setup new payment method"
        // backToBillingDetails: 'Back to billing address',
      },
      subscriptions_Checkout: {
        title: "Checkout",
        paymentMethod: "PAYMENT METHOD",
        paymentMethodError: "Unable to use payment method with checkout",
        nameOnCard: "Name on card",
        cardNumber: "Card Number",
        expiryDate: "Expiry Date",
        cvc: "CVC Security Number",
        selectedPlan: "SELECTED PLAN",
        priceIntervalMonthly: "Billed Monthly"
      },
      subscriptions_Cancellation: {
        title: "Cancel Plan",
        unknownDate: "Unknown date",
        description: "If you cancel now, you'll still enjoy all the features of your paid plan until {{expirationDate}}. You can resubscribe or switch to another paid plan anytime."
      },
      subscriptions_Renewal: {
        title: "Renew Plan",
        unknownDate: "Unknown date",
        description: "This plan will no longer be canceled. It will renew on {{renewalDate}}."
      },
      subscriptions_CheckoutDialog: {
        errorPlanNotFound: "Plan was not found."
      },
      allUsers: {
        pageTitle: "All Users",
        inviteUserButton: "Invite User",
        searchInputPlaceholder: "Search for any text...",
        searchingPlaceholder: "Searching...",
        meTooltip: "Me",
        userHeader: "User",
        rolesHeader: "Roles",
        accountsHeader: "Accounts",
        joinedHeader: "Joined",
        lastSeenHeader: "Last Seen",
        manageAction: "Manage",
        pendingApprovalStatus: "Pending approval",
        pendingActivationStatus: "Not activated",
        resendInvitationAction: "Resend invitation email",
        resendActivationAction: "Resend activation email",
        // logOutUserSessionsActions: 'Log out user sessions',
        leaveTeamAction: "Leave Team",
        deleteUserAction: "Delete",
        lockUserAction: "Lock",
        noUsersYet: "You didn't add nusers yet",
        noUsersYetDescription: "Add new users to see the results in your table",
        noResultFound: "No Result found",
        noResultFoundDescription: "It seems we can't find any results based on your search."
      },
      allUsers_DeleteUser: {
        title: "Delete {{name}} from all accounts?",
        areYouSureDeleteUser1: "You are about to delete {{name}} from all accounts.",
        areYouSureDeleteUser2: "If you delete it, you won't be able to undo",
        cancel: "Cancel",
        delete: "Delete"
      },
      allUsers_LockUser: {
        title: "Lock {{name}}?",
        areYouSureLockUser1: "Do you really want to lock {{name}}?",
        cancel: "Cancel",
        lock: "Lock"
      },
      allUsers_InviteUser: {
        title: "Invite User",
        inviteWithLinkSettings: "Invite with link settings",
        fullNameInputLabel: "Full Name",
        fullNameIsRequired: "Full name is required",
        emailInputLabel: "Email",
        emailIsRequired: "Email is required",
        emailMustBeValid: "Must be a valid email",
        rolesInputLabel: "Roles",
        rolesIsRequired: "At least one role is required",
        rolesInputPlaceholder: "Select roles",
        cancel: "Cancel",
        invite: "Invite",
        save: "Save",
        selected: "Selected",
        accountsCount_one: "{{count}} Account",
        accountsCount_other: "{{count}} Accounts",
        assignRole: "Assign role",
        accounts: "Accounts",
        role: "Role"
      },
      allUsers_EditInvitationLink: {
        title: "Invite with link settings",
        inviteWithLinkTitle: "Invite with link",
        expirationInputLabel: "Expiration",
        expirationInputPlaceholder: "Please select an option",
        linkExpiration: "Link will be expired in {{days}}",
        sendMeNotification: "Send me an email each time someone joins using this invitation link",
        notification: "Notification",
        deactivateLink: "Deactivate link",
        back: "Back",
        save: "Save",
        copyInviteLink: "Copy invite link",
        day: "day",
        days: "days",
        edit: "Edit"
      },
      allUsers_DeactivateInvitationLink: {
        title: "Deactivate link",
        areYouSureDeleteInviteLink: "Are you sure you want to deactivate invite link?",
        cancel: "Cancel",
        deactivate: "Deactivate"
      }
      // allAccounts: {
      //   pageTitle: 'All Accounts',
      //   createNewAccount: 'Create New Account',
      //   searchAccountPlaceholder: 'Search by account name',
      //   noAccountFound: 'No accounts found',
      //   toggleTextTable: 'Table',
      //   toggleTextGraph: 'Graph',
      // },
      // allAccounts_accountsTable: {
      //   accountColumn: 'Name',
      //   usersColumn: 'Users',
      //   createdColumn: 'Created',
      //   showMoreBtnText: 'Show more',
      //   openAccountBtnText: 'Open Account',
      //   editBtnText: 'Edit account name',
      //   deleteBtnText: 'Delete',
      // },
      // allAccounts_graph: {
      //   numberOfUsersText: 'Users',
      //   showMoreText: 'Show more',
      // },
      // allAccounts_CreateAccountDialog: {
      //   title: 'Create New Account',
      //   accountNameLabel: 'Account Name',
      //   parentAccountLabel: 'Parent Account',
      //   parentAccountPlaceholder: 'Select Parent Account',
      //   cancelBtnText: 'Cancel',
      //   createBtnText: 'Create',
      //   successDescription: '{{accountName}} account has been created',
      //   manageThisAccount: 'Manage account',
      //   doneBtnText: 'Done',
      // },
      // allAccounts_DeleteAccountDialog: {
      //   title: 'Delete {{accountName}}',
      //   description: 'Are you sure you want to delete this account?',
      //   description2:
      //     'Users who only belong to this account will be removed completely.',
      //   cancelBtnText: 'Cancel',
      //   deleteBtnText: 'Delete',
      //   warningDialogTitle: 'Cannot Delete Account',
      //   warningDialogText:
      //     'It looks like {{accountName}} account has child accounts. nPlease delete or reassign the child accounts before deleting this one.',
      //   warningDialogButtonText: 'OK',
      // },
      // allAccounts_EditAccountDialog: {
      //   title: 'Edit Account {{accountName}}',
      //   accountNameLabel: 'Account Name',
      //   cancelBtnText: 'Cancel',
      //   saveBtnText: 'Save',
      // },
      // singleAccountView: {
      //   pageTitle: 'Back to All Accounts',
      //   createSubAccount: 'Create Sub-Account',
      //   inviteUsers: 'Invite Users',
      //   usersCountText: 'Users',
      //   subAccounts: 'Sub-accounts',
      //   haveAccessToSubAccounts: 'have access to subuc0u8210 accounts',
      //   editAccountBtnText: 'Edit account name',
      //   deleteAccountBtnText: 'Delete',
      //   usersTab: 'Users',
      //   subAccountsTab: 'Sub-accounts',
      //   searchUserPlaceholder: 'Search by email',
      // },
      // singleAccountView_noPermissions: {
      //   noPermissionTitle: 'No access',
      //   noPermissionDescription: "You don't have access to this account.",
      //   noPermissionDescriptionForLink: 'You can go back to',
      //   allAccountsLinkText: 'All Accounts',
      // },
      // singleAccountView_usersTable: {
      //   usersColumn: 'Users',
      //   rolesColumn: 'Roles',
      //   joinedColumn: 'Joined',
      //   subAccountsAccessColumn: 'Sub-account access',
      //   subAccountsAccessColumnTooltip:
      //     'Toggling this on for a user will allow them to log in to all existing and future children of this account.',
      //   pendingApprovalStatus: 'Pending for Approval',
      //   pendingActivationStatus: 'Pending for Activation',
      //   meTooltip: 'Me',
      //   editUserRolesBtnText: 'Edit user roles',
      //   deleteUserBtnText: 'Delete user',
      //   noUsersText: 'No users yet',
      //   noUsersDescription: 'Add new users to see the results in your table',
      //   noResultsFoundText: 'No results found',
      //   noResultsFoundDescription:
      //     "It seems we can't find any results based on your search.",
      // },
      // singleAccountView_AddUsersDialog: {
      //   title: 'Invite users',
      //   emailInputLabel: 'Email',
      //   emailInputPlaceholder: 'Enter email',
      //   cancelBtnText: 'Cancel',
      //   inviteBtnText: 'Invite',
      //   emailValidationError: 'Email must be valid',
      //   emailRequiredError: 'Email is required',
      //   rolesRequiredError: 'At least one role is required',
      //   selectRoleLabel: 'Select Role',
      //   multipleRolesLabel: 'Multiple Roles',
      //   giveAccessToAllSubAccountsLabel:
      //     'Also give access to existing and future sub-accounts of this account',
      //   bulkInputLabelWithoutRoles: 'Email',
      //   bulkInputLabelWithRoles: 'Email & Role',
      //   bulkInputHelperText: 'You can invite up to 5 users at a time.',
      //   bulkInputDomainsRestrictionError:
      //     "Sorry, you can't invite users with this domain due to your organization's restrictions.",
      //   bulkInputPlaceholder: 'Type email address and press "Enter"',
      //   bulkInputDuplicatedEmailsError:
      //     'This email already exists, please provide a unique address',
      // },
      // singleAccountView_DeleteUserDialog: {
      //   title: 'Delete {{userName}}?',
      //   description: 'Are you sure you want to delete {{userName}}?',
      //   description2:
      //     '{{userName}} will be deleted from this account, existing sub-accounts, and future sub-accounts.',
      //   cancelBtnText: 'Cancel',
      //   deleteBtnText: 'Delete',
      // },
      // singleAccountView_EditUserRolesDialog: {
      //   title: 'Edit {{userName}} roles',
      //   cancelBtnText: 'Cancel',
      //   updateBtnText: 'Update',
      //   rolesRequiredError: 'At least one role is required',
      //   selectRolesLabel: 'Select roles',
      //   selectRolePlaceholder: 'Select role',
      // },
    }
  },
  de: {
    loginBox: {
      login: {
        title: "Anmelden",
        signUpMessage: "Haben Sie kein Konto?",
        signUpLink: "Registrieren",
        forgotPassword: "Passwort vergessen?",
        emailInputLabel: "E-Mail",
        emailInputPlaceholder: "name@example.de",
        passwordInputLabel: "Passwort",
        passwordInputPlaceholder: "Geben Sie Ihr Passwort ein",
        login: "Anmelden",
        continue: "Weiter",
        emailMustBeValid: "Ungültiges E-Mail-Format. Stellen Sie sicher, dass Ihre E-Mail korrekt ist",
        emailIsRequired: "E-Mail ist erforderlich",
        passwordMustBeCharacters: "Das Passwort muss mindestens {{length}} Zeichen lang sein",
        passwordIsRequired: "Passwort erforderlich",
        invalidTitle: "Konnte Sie nicht anmelden",
        signInWithSocialLogin: "oder anmelden mit",
        backToLogin: "Zurück zur Anmeldung",
        mfaTitle: "Multi-Faktor-Authentifizierung",
        mfaInputLabel: "Bitte geben Sie den sechsstelligen Code aus Ihrer Authenticator-App ein",
        mfaCodeIsRequired: "Code ist erforderlich",
        mfaCodeLengthAtLeast6: "Der Code muss mindestens 6 Zeichen lang sein",
        mfaRememberThisDevice: "Stellen Sie diese Frage nicht erneut auf diesem Gerät für {{count}} Tage",
        disableMultiFactorTitle: "Probleme?",
        disableMultiFactorMessage: "Multi-Faktor mit Wiederherstellungscode deaktivieren",
        recoverMfaTitle: "MFA-Wiederherstellungscode",
        disabledMultiFactorClickHereButton: "Hier klicken",
        enterRecoveryCode: "Bitte geben Sie Ihren MFA-Wiederherstellungscode ein",
        disabledMultiFactorButton: "MFA deaktivieren",
        twoFactorCodeIsRequired: "Code ist erforderlich",
        twoFactorCodeLengthAtLeast8: "Mindestlänge beträgt 8 Zeichen",
        missingPolicyErrorMessage: "Es scheint, als hätten wir Probleme beim Laden Ihrer Konfiguration",
        magicLinkTitle: "Zauberlink gesendet!",
        magicLinkText: "Wir haben eine E-Mail an {{email}} mit einem Link gesendet, um Sie schnell anzumelden.",
        magicLinkResend: "Erneut senden",
        invalidMagicLinkTitle: "Anmeldung nicht möglich",
        invalidMagicLinkText: "Ein Magic Link kann nur einmal verwendet werden.",
        smsOtcTitle: "Überprüfen Sie Ihre Telefonnummer",
        smsOtcMessage: "Bitte geben Sie den sechsstelligen Code ein, den wir an {{phoneNumber}} gesendet haben.",
        smsOtcChangePhoneMessage: "(Nicht Ihre Nummer? Ändern Sie sie hier)",
        otcTitle: "Überprüfen Sie Ihre E-Mail",
        otcMessage: "Wir haben Ihnen einen sechsstelligen Code an {{email}} gesendet",
        otcInputLabel: "Geben Sie den generierten 6-stelligen Code unten ein",
        otcInputPlaceholder: "6-stelliger Code",
        otcCodeIsRequired: "",
        otcContinue: "Weiter",
        otcHaventReceivedCode: "Haben Sie es nicht erhalten?",
        otcResend: "Code erneut senden",
        otcInvalidLengthCode: "Der Code sollte 6 Buchstaben haben",
        ssoRedirectToMessage: "Leitet Sie zur Anmeldeseite Ihrer Organisation weiter",
        failedOicdLoginTitle: "Anmeldung mit SSO fehlgeschlagen, versuchen Sie es später erneut.",
        failedOicdBackToLogin: "Zurück zur Anmeldung",
        failedSamlBackToLogin: "Zurück zur Anmeldung",
        failedSamlDefaultError: "Anmeldung mit SSO fehlgeschlagen, bitte versuchen Sie es später erneut.",
        joinTenantTitle: "Melden Sie sich beim Konto von {{tenantName}} an",
        failedJoinTenantTitle: "Dieser Einladungslink ist nicht aktiv",
        failedJoinTenantBackButton: "Zurück zur Anmeldung",
        forceMfaTitle: "Authenticator einrichten",
        forceMfaMessage: " Verwenden Sie Ihr Telefon, um den folgenden QR-Code mit Google Authenticator oder anderen Authenticator-Apps zu scannen. ",
        forceMfaScanQueryDescription1: "Verwenden Sie Ihr Telefon, um den folgenden QR-Code zu scannen mit ",
        forceMfaScanQueryDescription2: " oder andere Authentifikator-Apps.",
        forceMfaInputLabel: "Geben Sie den generierten 6-stelligen Code unten ein.",
        forceMfaInputPlaceholder: "Beispiel. 1 2 3 4 5 6",
        forceMfaVerifyButton: "Verifizieren",
        forceMfaRememberThisDevice: "Frage nicht erneut auf diesem Gerät für {{count}} Tage",
        splitLogin: {
          titleDescriptionComponent: {
            companyName: "",
            titleAfterCompanyName: "",
            titleBeforeCompanyName: "Mit {Firmenname} können Sie anfangen zu bauen",
            description: "Erstellen Sie Ihr Konto und beginnen Sie es heute zu nutzen! Es dauert nur wenige Sekunden, also melden Sie sich an."
          },
          testimonialComponent: {
            testimonial1: {
              label: "John Doe",
              subtitle: "Softwareentwickler @Company",
              text: "Wir haben Frontegg in nur wenigen Stunden integriert. Wir mussten buchstäblich nur die Kästchen ankreuzen, um loszulegen. Unser Entwicklerteam liebt es."
            }
          },
          valuesComponent: {
            value1: "Jeden Tag macht {Unternehmensname} Tausende von Kunden glücklich.",
            value2: "Erstellen Sie Ihr Konto und beginnen Sie Ihre Reise mit uns.",
            value3: "{Firmenname} hilft Ihnen zu wachsen! Melden Sie sich an und wählen Sie Ihren Plan."
          }
        },
        disclaimerText: "Ich stimme dem zu:",
        termsLinkText: "Allgemeine Geschäftsbedingungen",
        termsLink: "https://app.termly.io/document/privacy-policy/71fec9f3-2088-475a-8106-9a590b6e0c0f",
        privacyLinkText: "Datenschutzrichtlinie",
        privacyLink: "https://app.termly.io/document/privacy-policy/71fec9f3-2088-475a-8106-9a590b6e0c0f",
        termsAndPrivacyConjunctionText: "und",
        oneTouchLoginTitle: "Mit Touch ID anmelden",
        oneTouchLoginMessage: "Melden Sie sich mit einem Fingerdruck an",
        oneTouchLoginButton: "Mit Touch ID einloggen",
        touchId: "Touch ID",
        androidLoginTitle: "Mit Android anmelden",
        androidLoginMessage: "Erhalten Sie eine Benachrichtigung auf Ihrem Android",
        androidLoginButton: "Mit Android anmelden",
        android: "Android",
        usbLoginTitle: "Mit USB-Schlüssel anmelden",
        usbLoginMessage: "Schließen Sie Ihren USB-Schlüssel an, um sich anzumelden",
        usbLoginButton: "Mit USB-Schlüssel anmelden",
        usb: "USB-Schlüssel",
        smsLoginTitle: "Mit SMS anmelden",
        smsLoginMessage: "Geben Sie Ihre Telefonnummer ein, um eine PIN zu erhalten",
        smsLoginButton: "Mit SMS anmelden",
        smsLoginChangePhoneTitle: "Was ist deine Nummer?",
        smsLoginChangePhoneMessage: "Geben Sie Ihre Telefonnummer ein, um eine PIN zu erhalten",
        smsLoginChangePhoneInputLabel: "Telefonnummer",
        smsLoginChangePhoneButton: "Schick mir eine SMS",
        smsLoginPinTitle: "Bestätigen Sie, dass Sie es sind",
        smsLoginPinMessage: "Bitte geben Sie den sechsstelligen Code ein, den wir an {{phoneNumber}} gesendet haben.",
        smsLoginPinButton: "Überprüfen",
        sms: "SMS",
        loginWelcomeTitle: "Willkommen zurück",
        loginWelcomeSubtitleSubtitle: "Wie möchten Sie sich anmelden?",
        loginWelcomeKnownUserSubtitle: "Melden Sie sich schnell wieder bei Ihrem Konto an",
        registerNewQuickLoginTitle: "Gute Wahl! Aber bitte melden Sie sich zuerst mit Ihrer E-Mail an",
        registerNewQuickLoginSubtitle: "Dann richten wir die Anmeldung mit {{type}} für Sie ein",
        phoneIsRequired: "Telefonnummer ist erforderlich",
        phoneIsInvalid: "Muss eine gültige Telefonnummer sein"
      },
      acceptInvitation: {
        title: "Einladung annehmen",
        successTitle: "Sie haben sich erfolgreich angemeldet!",
        successMessage: "Sie werden in wenigen Sekunden zum Anmeldebildschirm weitergeleitet. ",
        invalidTitle: "Dieser Einladungslink ist nicht mehr aktiv",
        invalidMessage: "Ein Anmeldelink kann nur einmal verwendet werden. Für einen neuen Link kontaktieren Sie bitte die Person, die ihn mit Ihnen geteilt hat.",
        invalidBackToLoginButton: "Zurück zur Anmeldung"
      },
      activateAccount: {
        title: "Aktivieren Sie Ihr Konto",
        newPasswordInputLabel: "Neues Passwort",
        newPasswordInputPlaceholder: "Legen Sie ein Passwort fest",
        newPasswordIsRequired: "Passwort ist erforderlich",
        confirmPasswordInputLabel: "Neues Passwort bestätigen",
        confirmPasswordInputPlaceholder: "Passwort erneut eingeben",
        confirmPasswordIsRequired: "Bestätigung des Passworts ist erforderlich",
        confirmPasswordMustMatch: "Passwörter müssen übereinstimmen",
        activateButton: "Aktivieren",
        successTitle: "Erfolgreich aktiviert!",
        successMessage: "Sie können jetzt Ihr neues Passwort verwenden, um sich bei Ihrem Konto anzumelden. Die Anmeldeseite wird in wenigen Sekunden automatisch angezeigt.",
        failedTitle: "Aktivierung fehlgeschlagen",
        failedMessage: "Bitte überprüfen Sie Ihre Aktivierungs-URL noch einmal",
        linkExpiredTitle: "Aktivierungslink abgelaufen",
        linkExpiredMessage: "Ein Aktivierungslink kann nur einmal verwendet werden",
        linkFailedTitle: "Kontoaktivierung fehlgeschlagen",
        linkFailedMessage: "Bitte überprüfen Sie Ihre Aktivierungs-URL noch einmal",
        failedBackToLoginButton: "Zurück zur Anmeldung"
      },
      recoveryMfa: {
        title: "Der Wiederherstellungscode kann verwendet werden, um die Multi-Faktor-Authentifizierung zu deaktivieren, falls Sie Ihr Telefon verlieren.",
        recoveryCodeLabel: "Ihr Wiederherstellungscode",
        copyAndSaveCode: "Kopieren und speichern Sie den Code. Wir werden ihn nicht noch einmal anzeigen.",
        continueButton: "Erledigt"
      },
      forgetPassword: {
        title: "Passwort vergessen?",
        description: "Gib deine registrierte E-Mail-Adresse ein – wir schicken dir dann einen Link, mit dem du dein Passwort zurücksetzen können.",
        emailInputLabel: "E-Mail",
        emailInputPlaceholder: "name@example.de",
        emailIsRequired: "E-Mail ist erforderlich",
        emailMustBeValid: "Muss eine gültige E-Mail sein",
        submitButtonText: "Passwort zurücksetzen",
        backToLogin: "Zurück zur Anmeldung",
        resetEmailSentTitle: "Überprüfen Sie Ihren Posteingang",
        resetEmailSentMessage: "Wir haben eine E-Mail an {{email}} mit Anweisungen zum Zurücksetzen Ihres Passworts gesendet."
      },
      resetPhoneNumber: {
        emailInputLabel: "E-Mail",
        emailInputPlaceholder: "name@example.de",
        emailIsRequired: "E-Mail ist erforderlich",
        emailMustBeValid: "Muss eine gültige E-Mail sein",
        continue: "Weiter",
        resetPhoneNumberTitle: "Telefonnummer ändern",
        resetPhoneOtcTitle: "Bestätigen Sie, dass Sie es sind",
        resetPhoneOtcMessage: "Bitte geben Sie den sechsstelligen Code ein, den wir an Ihre E-Mail gesendet haben",
        changePhoneNumberTitle: "Geben Sie Ihre Telefonnummer ein",
        changePhoneNumberMessage: "Bitte geben Sie unten Ihre Telefonnummer ein",
        phoneInputLabel: "Telefonnummer",
        phoneInputPlaceholder: "Geben Sie Ihre Telefonnummer ein",
        phoneIsRequired: "Telefonnummer ist erforderlich",
        phoneIsInvalid: "Muss eine gültige Telefonnummer sein",
        backToLogin: "Zurück zur Anmeldung"
      },
      resetPassword: {
        title: "Passwort zurücksetzen",
        description: "",
        newPasswordInputLabel: "Neues Passwort",
        newPasswordInputPlaceholder: "Legen Sie ein Passwort fest",
        newPasswordIsRequired: "Neues Passwort ist erforderlich",
        confirmPasswordInputLabel: "Neues Passwort bestätigen",
        confirmPasswordInputPlaceholder: "Passwort erneut eingeben",
        confirmPasswordIsRequired: "Bestätigung des Passworts ist erforderlich",
        confirmPasswordMustMatch: "Passwörter müssen übereinstimmen",
        resetPasswordButton: "Passwort zurücksetzen",
        successTitle: "Passwort geändert!",
        successMessage: "Sie können jetzt Ihr neues Passwort verwenden, um sich bei Ihrem Konto anzumelden. Die Anmeldeseite wird in wenigen Sekunden automatisch angezeigt.",
        failedTitle: "Zurücksetzen des Passworts fehlgeschlagen",
        failedMessage: "Bitte überprüfen Sie Ihre Reset-URL noch einmal",
        failedBackToLoginButton: "Zurück zur Anmeldung"
      },
      socialLogins: {
        loginButtonText: "Fortfahren mit",
        signupButtonText: "Mit {{providerName}} anmelden",
        activationButtonText: "Melden Sie sich bei {{providerName}} an",
        invalidTitle: "Konnte Sie nicht anmelden",
        failedInvalidCallbackUrl: "Ungültige Rückruf-URL",
        failedBackToLogin: "Zurück zur Anmeldung"
      }
    },
    validation: {
      passwordMinLength: "Mindestens {{length}} Zeichen",
      passwordMaxLength: "Maximal {{length}} Zeichen",
      passwordThreeRepeatedChars: "vermeiden Sie 3 oder mehr wiederkehrende Zeichen",
      passwordAtLeastOneLowerLetter: "1 Kleinbuchstabe",
      passwordAtLeastOneUpperLetter: "1 Großbuchstabe",
      passwordAtLeastOneNumber: "1 Nummer",
      passwordAtLeastOneSpecialChar: "1 Sonderzeichen"
    },
    validations: {
      passwordMinLength: "Mindestens {{length}} Zeichen",
      passwordMaxLength: "Maximal {{length}} Zeichen",
      passwordThreeRepeatedChars: "vermeiden Sie 3 oder mehr wiederkehrende Zeichen",
      passwordAtLeastOneLowerLetter: "1 Kleinbuchstabe",
      passwordAtLeastOneUpperLetter: "1 Großbuchstabe",
      passwordAtLeastOneNumber: "1 Nummer",
      passwordAtLeastOneSpecialChar: "1 Sonderzeichen"
    },
    adminPortal: {
      navigation: {
        // required for @frontegg/react@v7
        // myAccount: 'Mein Konto',
        workspace: "Workspace",
        allAccounts: "Alle Konten",
        poweredBy: "Angetrieben von",
        profile: "Profil",
        privacy: "Sicherheit",
        personalApiTokens: "Persönliche Token",
        usage: "Nutzung",
        account: "Account Details",
        users: "Nutzer",
        allUsers: "Alle Nutzer",
        roles: "Rollen",
        security: "Sicherheit",
        sso: "SSO",
        audits: "Auditprotokolle",
        webhooks: "Webhooks",
        apiTokens: "API Token",
        subscriptions: "Abo",
        login: "Login"
      },
      profile: {
        pageTitle: "Profil",
        name: "Name",
        email: "E-Mail",
        phone: "Telefonnummer",
        address: "Adresse",
        jobTitle: "Stellenbezeichnung",
        informationTitle: "Grundlegende Profilinformationen",
        uploadImage: "Bild hochladen",
        removeImage: "Bild entfernen",
        removeImageTitle: "Bild entfernen",
        removeImageMessage: "Sind Sie sicher, dass Sie Ihr Bild entfernen möchten?",
        removeImageButton: "Entfernen",
        removeImageCancelButton: "Abbrechen"
      },
      profile_EditName: {
        title: "Name bearbeiten",
        displayNameInputLabel: "Anzeigename",
        firstNameInputLabel: "Vorname",
        firstNameIsRequired: "Vorname ist erforderlich",
        lastNameInputLabel: "Nachname",
        nameTitle: "Titel",
        nameTitle_mr: "Herr",
        nameTitle_mrs: "Frau",
        nameTitle_miss: "Frau",
        nameTitle_ms: "Frau",
        nameTitle_dr: "Dr",
        nameTitle_phd: "PhD",
        cancel: "Abbrechen",
        save: "Speichern"
      },
      profile_EditJobTitle: {
        title: "Jobtitel bearbeiten",
        jobTitleInputLabel: "Stellenbezeichnung",
        cancel: "Abbrechen",
        save: "Speichern"
      },
      profile_EditPhone: {
        title: "Telefonnummer bearbeiten",
        phoneInputLabel: "Telefonnummer",
        phoneIsRequired: "Telefonnummer ist erforderlich",
        phoneIsInvalid: "Muss eine gültige Telefonnummer sein",
        cancel: "Abbrechen",
        save: "Speichern"
      },
      profile_EditAddress: {
        title: "Adresse bearbeiten",
        address1InputLabel: "Adresse 1",
        address1IsRequired: "Adresse 1 ist erforderlich",
        address2InputLabel: "Adresse 2",
        address2IsRequired: "Adresse 2 ist erforderlich",
        cityInputLabel: "Stadt",
        cityIsRequired: "Stadt ist erforderlich",
        stateInputLabel: "Bundesland",
        stateInputIsRequired: "Bundesland ist erforderlich",
        postCodeInputLabel: "Postleitzahl",
        postCodeIsInvalid: "Muss eine gültige Postleitzahl sein",
        postCodeIsRequired: "Postleitzahl ist erforderlich",
        countryInputLabel: "Land",
        countryInputPlaceholder: "Land auswählen",
        countryIsRequired: "Land ist erforderlich",
        cancel: "Abbrechen",
        save: "Speichern"
      },
      personalTokens: {
        pageTitle: "Persönliche Zugriffstoken",
        searchInputPlaceholder: "Suche nach beliebigem Text...",
        generateTokenButton: "Token generieren",
        noApiTokensYet: "Sie haben noch keine API-Token.",
        noApiTokensYetDescription: "Fügen Sie ein neues API-Token hinzu, um die Ergebnisse in Ihrer Tabelle zu sehen",
        noResultFound: "Keine Ergebnisse gefunden",
        noResultFoundDescription: "Es scheint, dass wir keine Ergebnisse basierend auf Ihrer Suche finden können.",
        clientIdHeader: "Beschreibung",
        createdOnHeader: "Erstellt am",
        deleteApiTokenAction: "API Token löschen"
      },
      personalTokens_AddToken: {
        title: "Token generieren",
        successTitle: "Ihr API-Schlüssel wurde erfolgreich generiert!",
        descriptionInputLabel: "Beschreibung",
        descriptionIsRequired: "Beschreibung ist erforderlich",
        clientId: "Kunden-ID",
        secretKey: "Geheimschlüssel",
        copyAndSaveId: "Kopieren und speichern Sie die untenstehende ID und das Geheimnis, denn wir werden es nicht noch einmal anzeigen.",
        cancel: "Abbrechen",
        create: "Erstellen",
        done: "Erledigt"
      },
      personalTokens_DeleteToken: {
        title: "API-Token löschen?",
        areYouSureDeleteApiToken1: "Sind Sie sicher, dass Sie löschen möchten",
        areYouSureDeleteApiToken2: "Sie werden diesen Vorgang nicht rückgängig machen können",
        cancel: "Abbrechen",
        delete: "Löschen"
      },
      auditLogs: {
        pageTitle: "Auditprotokolle",
        searchInputPlaceholder: "Suche nach beliebigem Text...",
        downloadCsv: "CSV herunterladen",
        downloadCsvPrimaryButton: "Herunterladen",
        noResultFound: "Keine Ergebnisse gefunden",
        noResultFoundDescription: "Es scheint, dass wir keine Ergebnisse basierend auf Ihrer Suche finden können.",
        searchingPlaceholder: "Suche läuft...",
        clear: "Löschen",
        cancel: "Abbrechen",
        filter: "Filter",
        filterBy: "Filtern nach"
      },
      apiTokens: {
        pageTitle: "API Token",
        searchInputPlaceholder: "Suche nach beliebigem Text...",
        generateTokenButton: "Token generieren",
        noApiTokensYet: "Sie haben noch keine API-Token.",
        noApiTokensYetDescription: "Fügen Sie ein neues API-Token hinzu, um die Ergebnisse in Ihrer Tabelle zu sehen",
        noResultFound: "Keine Ergebnisse gefunden",
        noResultFoundDescription: "Es scheint, dass wir keine Ergebnisse basierend auf Ihrer Suche finden können.",
        clientIdHeader: "Beschreibung",
        createdOnHeader: "Erstellt am",
        createdByHeader: "Erstellt von",
        rolesHeader: "Rollen",
        deleteApiTokenAction: "API Token löschen"
      },
      apiTokens_AddToken: {
        title: "Token generieren",
        successTitle: "Ihr API-Schlüssel wurde erfolgreich generiert!",
        descriptionInputLabel: "Beschreibung",
        descriptionIsRequired: "Beschreibung ist erforderlich",
        clientId: "Kunden-ID",
        secretKey: "Geheimschlüssel",
        copyAndSaveId: "Kopieren und speichern Sie die untenstehende ID und das Geheimnis, da wir es nicht noch einmal anzeigen werden.",
        rolesInputLabel: "Rollen",
        rolesInputPlaceholder: "Rolle auswählen",
        rolesIsRequired: "Mindestens eine Rolle ist erforderlich",
        cancel: "Abbrechen",
        create: "Erstellen",
        done: "Erledigt"
      },
      apiTokens_DeleteToken: {
        title: "API-Token löschen?",
        areYouSureDeleteApiToken1: "Sind Sie sicher, dass Sie löschen möchten",
        areYouSureDeleteApiToken2: "Sie werden diesen Prozess nicht rückgängig machen können",
        cancel: "Abbrechen",
        delete: "Löschen"
      },
      accountSettings: {
        pageTitle: "Account Details",
        subtitle: "Einstellungen",
        companyName: "Firmenname",
        address: "Adresse",
        website: "Webseite",
        timezone: "Zeitzone",
        currency: "Währung",
        addCompanyButton: "Firmennamen hinzufügen",
        addAddressButton: "Firmenadresse hinzufügen",
        addWebsiteButton: "Website hinzufügen",
        setTimezoneButton: "Standardzeitzone festlegen",
        setCurrencyButton: "Standardwährung festlegen"
      },
      accountSettings_EditAddress: {
        title: "Adresse bearbeiten",
        address1InputLabel: "Adresse 1",
        address1IsRequired: "Adresse 1 ist erforderlich",
        address2InputLabel: "Adresse 2",
        address2IsRequired: "Adresse 2 ist erforderlich",
        cityInputLabel: "Stadt",
        cityIsRequired: "Stadt ist erforderlich",
        stateInputLabel: "Bundesland",
        stateInputIsRequired: "Bundesland ist erforderlich",
        postCodeInputLabel: "Postleitzahl",
        postCodeIsInvalid: "Muss eine gültige Postleitzahl sein",
        postCodeIsRequired: "Postleitzahl ist erforderlich",
        countryInputLabel: "Land",
        countryInputPlaceholder: "Wählen Sie Ihr Land",
        countryIsRequired: "Land ist erforderlich",
        cancel: "Abbrechen",
        save: "Speichern"
      },
      accountSettings_EditCompanyName: {
        title: "Name bearbeiten",
        companyNameLabel: "Firmenname",
        companyNameIsRequired: "Firmenname ist erforderlich",
        save: "Speichern",
        cancel: "Abbrechen"
      },
      accountSettings_EditWebsite: {
        title: "Website bearbeiten",
        websiteInputLabel: "Website-URL",
        save: "Speichern",
        cancel: "Abbrechen"
      },
      accountSettings_EditTimezone: {
        title: "Zeitzone bearbeiten",
        timezoneInputLabel: "Zeitzone",
        save: "Speichern",
        cancel: "Abbrechen"
      },
      accountSettings_EditCurrency: {
        title: "Währung ändern",
        currencyLabel: "Währung",
        save: "Speichern",
        cancel: "Abbrechen"
      },
      privacy: {
        pageTitle: "Sicherheit",
        basicSettings: "Grundeinstellungen",
        passwordTitle: "Passwort",
        mfaTitle: "Multi-Faktor-Authentifizierung",
        mfaRequired: "Erforderlich",
        mfaHelpMessage: "Multi-Faktorauthentifizierung ist für mindestens eine Organisation, mit der Sie verbunden sind, erforderlich.",
        mfaEnabled: "Aktiviert",
        mfaDisabled: "Deaktiviert"
      },
      privacy_ChangePassword: {
        title: "Passwort ändern",
        currentPasswordInputLabel: "Aktuelles Passwort",
        currentPasswordIsRequired: "Aktuelles Password ist erforderlich",
        newPasswordInputLabel: "Neues Passwort",
        newPasswordIsRequired: "Neues Passwort ist erforderlich",
        confirmPasswordInputLabel: "Neues Passwort bestätigen",
        confirmPasswordIsRequired: "Bestätigung des Passworts ist erforderlich",
        confirmPasswordMustMatch: "Passwörter müssen übereinstimmen",
        changePassword: "Passwort ändern",
        cancel: "Abbrechen"
      },
      privacy_DisableMfa: {
        title: "Deaktivieren Sie die mehrstufige Authentifizierung",
        description: "Das Deaktivieren der Multi-Faktorauthentifizierung entfernt eine zusätzliche Sicherheitsebene.",
        tokenInputLabel: "Geben Sie den generierten 6-stelligen Code unten ein",
        tokenInputLabelPlaceholder: "6-stelliger Code",
        codeIsRequired: "Code ist erforderlich",
        codeLengthAtLeast6: "Mindestlänge beträgt 6 Zeichen",
        cancel: "Abbrechen",
        disable: "Deaktivieren"
      },
      privacy_EnableMfa: {
        title: "Multi-Faktor-Authentifizierung",
        subtitle: "Aktivieren Sie MFA, um eine zusätzliche Sicherheitsebene zu erhalten.",
        scanDescription1: "Verwenden Sie Ihr Telefon, um den folgenden QR-Code zu scannen",
        scanDescription2: "oder andere Authenticator-Apps.",
        codeInputLabel: "Geben Sie den generierten 6-stelligen Code unten ein",
        codeInputPlaceholder: "6-stelliger Code",
        codeIsRequired: "Code ist erforderlich",
        codeLengthAtLeast6: "Mindestlänge beträgt 6 Zeichen",
        recoveryCodeTitle: "Der Wiederherstellungscode kann verwendet werden, um die Multi-Faktor-Authentifizierung zu deaktivieren, falls Sie Ihr Telefon verlieren.",
        recoveryCodeLabel: "Ihr Wiederherstellungscode",
        recoveryCodeInstructions: "Kopieren und speichern Sie den Code, denn wir werden ihn nicht noch einmal anzeigen.",
        cancel: "Abbrechen",
        verify: "Verifizieren",
        close: "Schließen"
      },
      security: {
        pageTitle: "Sicherheit",
        subtitle: "Einstellungen",
        mfaTitle: "MFA",
        mfaPolicyDontForceDescription: "MFA ist erlaubt, aber nicht durchgesetzt",
        mfaPolicyForceDescription: "Alle Benutzer werden gezwungen, MFA zu aktivieren",
        mfaPolicyForceExceptSAMLDescription: "Alle Nicht-SAML-Benutzer werden gezwungen, MFA zu aktivieren",
        lockoutTitle: "Benutzersperre",
        lockoutNotConfigured: "Sperrung nicht konfiguriert",
        lockoutEnabledMaxAttempts1: "Benutzer wird gesperrt nach",
        lockoutEnabledMaxAttempts2: "Falsche Passwortversuche",
        lockoutDisabled: "Sperrung deaktiviert",
        passwordHistoryTitle: "Passworthistorie",
        passwordHistoryNotConfigured: "Passworthistorie nicht konfiguriert",
        passwordHistoryEnabledHistorySize1: "Passwörter ablehnen, die identisch sind mit",
        passwordHistoryEnabledHistorySize2: "zuletzt verwendetes Passwort.",
        passwordHistoryDisabled: "Verlauf der Passwörter deaktiviert"
      },
      security_EditMfaPolicy: {
        title: "MFA-Richtlinie",
        dontForceTitle: "Nicht erzwingen",
        dontForceDescription: "MFA ist erlaubt, aber nicht erzwungen",
        forceTitle: "Erzwingen",
        forceDescription: "Alle Benutzer werden gezwungen, MFA zu aktivieren",
        forceExceptSAMLTitle: "Erzwinge außer Enterprise SSO",
        forceExceptSAMLDescription: "Alle nicht-unternehmensbezogenen SSO-Benutzer werden gezwungen, MFA zu aktivieren",
        cancel: "Abbrechen",
        save: "Speichern"
      },
      security_EditLockoutPolicy: {
        title: "Benutzersperrrichtlinie",
        attemptsInputLabel: "Maximale Anzahl ungültiger Anmeldeversuche",
        attemptsInputPlaceholder: "Beispiel: nach 5 falschen Passworteingaben",
        attemptsInputErrorMessage: "Muss eine positive Zahl sein",
        cancel: "Abbrechen",
        save: "Speichern"
      },
      security_EditPasswordHistoryPolicy: {
        title: "Passworthistorie-Richtlinie",
        sizeInputLabel: "Verlauf Größe",
        sizeInputPlaceholder: "",
        sizeIsRequired: "Größe des Verlaufs ist erforderlich",
        sizeMustBeNumber: "Muss eine positive Zahl sein",
        sizeMustBeGt0: "Muss größer oder gleich 0 sein",
        sizeMustBelt10: "Muss kleiner oder gleich 10 sein",
        cancel: "Abbrechen",
        save: "Speichern"
      },
      roles: {
        pageTitle: "Rollen & Berechtigungen",
        actionsHeader: "Aktionen",
        addNewRoleButton: "Rolle hinzufügen",
        searchInputPlaceholder: "Suche nach beliebigem Text...",
        searchingPlaceholder: "Suche nach Rollen...",
        noRolesYet: "Sie haben noch keine Rollen hinzugefügt",
        noRolesYetDescription: "Fügen Sie neue Rollen hinzu, um die Ergebnisse in Ihrer Tabelle zu sehen",
        noResultFound: "Kein Ergebnis gefunden",
        noResultFoundDescription: "Es scheint, dass wir keine Ergebnisse basierend auf Ihrer Suche finden können."
      },
      roles_AddRole: {
        title: "Neue Rolle hinzufügen",
        nameInputLabel: "Rollenname",
        nameIsRequired: "Rollenname ist erforderlich",
        keyInputLabel: "Rollenschlüssel",
        keyIsRequired: "Rollenschlüssel ist erforderlich",
        descriptionInputLabel: "Rollenbeschreibung",
        inheritPermissionInputLabel: "Standardrolle zum Erben von Berechtigungen:",
        inheritPermissionInputPlaceholder: "Rolle auswählen",
        cancel: "Abbrechen",
        create: "Erstellen"
      },
      sso: {
        pageTitle: "Single Sign On",
        enableAlert: "Bitte beachten Sie, dass Sie alle SSO-Schritte konfigurieren müssen, bevor Sie es aktivieren.",
        subtitle: "Konfigurierung",
        stepOneTitle: "Konfigurieren Sie Ihren IDP",
        stepOne: "Schritt 1",
        stepTwoTitle: "Domain beanspruchen",
        stepTwo: "Schritt 2",
        stepThreeTitle: "Berechtigung verwalten",
        stepThree: "Schritt 3",
        enableTitle: "Single Sign On aktivieren",
        switchProviderAlert: "Die Authentifizierung durch {{provider}} wird nicht mehr unterstützt."
      },
      sso_Header: {
        title: "SSO-Verbindungen",
        addNew: "Neu hinzufügen"
      },
      sso_Table: {
        editSSOConfig: "Bearbeiten",
        deleteSSOConfig: "Löschen",
        areYouSureDeleteSSOConfig: "Sind Sie sicher, dass Sie diese SSO-Verbindung löschen möchten? Sie können diesen Vorgang nicht rückgängig machen",
        deleteSSOConfigTitle: "SSO-Verbindung löschen?",
        noSSOConfigsYet: "Sie haben SSO noch nicht konfiguriert",
        noSSOConfigsYetDescription: "Fügen Sie eine neue SSO-Verbindung hinzu, um die Ergebnisse in Ihrer Tabelle zu sehen",
        cancel: "Abbrechen",
        back: "Zurück",
        done: "Erledigt",
        proceed: "Fortfahren",
        skip: "Überspringen",
        rolesColumnName: "Rollen",
        domainsColumnName: "Domänen",
        idpColumnName: "IDP",
        statusColumnName: "Status"
      },
      sso_ClaimDomain: {
        claimDomainText: "Kopieren Sie diese Informationen in einen neuen TXT-Datensatz in Ihrer DNS-Datei:",
        title: "Schritt 1 - Domain beanspruchen",
        domainInputLabel: "Domainname",
        domainInputPlaceholder: "Geben Sie die SSO-Domain ein",
        domainIsRequired: "Domainname ist erforderlich",
        domainMustBeValid: "Muss eine gültige Domain sein",
        domainValidatedMessage: "Domain-validiert",
        recordNameLabel: "Aufzeichnungsname",
        recordValueLabel: "Aufzeichnungswert",
        validate: "Validieren",
        proceed: "Fortführen",
        save: "Speichern",
        close: "Schließen",
        next: "Weiter",
        saveAndEnable: "SSO speichern und aktivieren",
        cancel: "Abbrechen"
      },
      sso_ConfigureIdp: {
        title: "Schritt 2 - Konfigurieren Sie Ihren IDP",
        enabled: "Aktiviert",
        successfullyEnabledMessage: "Single Sign On ist",
        successfullyIdpConfigured: "IDP Konfiguriert",
        radioAutomaticLabel: "AUTOMATICH",
        radioManualLabel: "ANLEITUNG",
        metadataFileLabel: "Metadatendatei",
        metadataFileDescription: "XML-Datei mit Ihren Konfigurationen",
        metadataFileTypeErrorMessage: "Dieser Dateityp ist ungültig. Bitte fügen Sie eine xml ein",
        metadataFileIsRequired: "Metadatendatei ist erforderlich",
        idpSelectLabel: "Wählen Sie Ihren Verbindungstyp",
        acsUrlInputLabel: "ACS URL",
        entityIdInputLabel: "Entitäts-ID",
        endpointInputLabel: "SSO-Endpunkt",
        endpointInputPlaceholder: "URL vom SSO",
        endpointIsRequired: "Endpunkt ist erforderlich",
        endpointUrlIsInvalid: "Endpunkt muss eine gültige URL sein",
        issuerUrlInputLabel: "Aussteller-URL",
        issuerUrlIsRequired: "Aussteller-URL ist erforderlich",
        issuerUrlIsInvalid: "Die Aussteller-URL muss eine gültige URL sein",
        issuerUrlInputHelpMessage: "Die Open ID Connect Well Known URL, vom IDP bereitgestellt",
        ssoWellKnownError: "Wir konnten Ihre Aussteller-URL nicht überprüfen",
        publicCertificateInputLabel: "Öffentliches Zertifikat",
        publicCertificateInputPlaceholder: "Öffentliches Zertifikat bereitstellen",
        publicCertificateIsRequired: "Öffentliches Zertifikat ist erforderlich",
        clientIdInputLabel: "Client id",
        clientIdInputPlaceholder: "Client id",
        clientIdIsRequired: "Client id ist erforderlich",
        secretInputLabel: "Geheimschlüssel",
        secretInputPlaceholder: "Geheimschlüssel",
        secretIsRequired: "Geheimschlüssel ist erforderlich",
        redirectUriInputLabel: "Weiterleitungs-URI",
        validate: "Validieren",
        proceed: "Fortfahren",
        save: "Speichern",
        close: "Schließen",
        next: "Weiter",
        saveAndEnable: "SSO speichern und aktivieren",
        cancel: "Abbrechen"
      },
      sso_ManageAuthorization: {
        title: "Schritt 3 - Berechtigungen verwalten",
        enabled: "Aktiviert",
        rolesIsRequired: "Mindestens eine Rolle ist erforderlich",
        selectRolesLabel: "Standard SSO-Rollen",
        rolesInputLabel: "Rollen",
        rolesInputPlaceholder: "Rollen auswählen",
        selectRolesHelpMessage: "Diese Rollen werden standardmäßig Benutzern zugewiesen, die sich über SSO anmelden",
        successfullyAuthorizationManaged: "",
        successfullyEnabledMessage: "Single Sign On ist",
        addMapping: "Mapping hinzufügen",
        group: "Gruppe",
        roles: "Rollen",
        rolesGroupsMappingTitle: "Rollen-Gruppen-Zuordnung",
        rolesGroupsMappingDescription: "Weisen Sie automatisch zusätzliche Rollen gemäß Ihren Identitätsanbietergruppen zu",
        rolesGroupsMappingError: "Gruppe muss mindestens 1 Rolle haben",
        rolesGroupsNameEmptyError: "Gruppenname kann nicht leer sein",
        rolesGroupsNameDuplicateError: "Gruppenname muss einzigartig sein",
        ssoAddMapping: "Mapping hinzufügen",
        validate: "Validieren",
        proceed: "Fortfahren",
        save: "Speichern",
        close: "Schließen",
        next: "Weiter",
        saveAndEnable: "SSO speichern und aktivieren",
        cancel: "Abbrechen"
      },
      users: {
        pageTitle: "Benutzer",
        inviteUserButton: "Benutzer einladen",
        searchInputPlaceholder: "Suche nach beliebigem Text...",
        searchingPlaceholder: "Suche läuft...",
        meTooltip: "Ich",
        userHeader: "Benutzer",
        rolesHeader: "Rollen",
        organizationHeader: "Organisation",
        joinedHeader: "Beigetreten",
        lastSeenHeader: "Zuletzt gesehen",
        editRolesAction: "Rollen bearbeiten",
        pendingApprovalStatus: "Ausstehende Genehmigung",
        pendingActivationStatus: "Nicht aktiviert",
        resendInvitationAction: "Einladungs-E-Mail erneut senden",
        resendActivationAction: "Aktivierungsemail erneut senden",
        leaveTeamAction: "Team verlassen",
        deleteUserAction: "Benutzer löschen",
        noUsersYet: "Sie haben noch keine Benutzer hinzugefügt",
        noUsersYetDescription: "Fügen Sie neue Benutzer hinzu, um die Ergebnisse in Ihrer Tabelle zu sehen",
        noResultFound: "Keine Ergebnisse gefunden",
        noResultFoundDescription: "Es scheint, dass wir keine Ergebnisse basierend auf Ihrer Suche finden können."
      },
      users_DeleteUser: {
        title: "Nutzer löschen",
        areYouSureDeleteUser1: "Sind Sie sicher, dass Sie löschen möchten",
        areYouSureDeleteUser2: "Sie werden diesen Prozess nicht rückgängig machen können.",
        cancel: "Abbrechen",
        delete: "Löschen"
      },
      users_EditUserRoles: {
        title: "Rollen bearbeiten",
        selectRolesLabel: "Standardrollen",
        selectRolesPlaceholder: "Standardrollen für Benutzer auswählen",
        cancel: "Abbrechen",
        update: "Update"
      },
      users_InviteUser: {
        title: "Nutzer einladen",
        inviteWithLinkSettings: "Mit Link-Einstellungen einladen",
        firstNameInputLabel: "Vorname",
        firstNameIsRequired: "Vorname ist erforderlich",
        lastNameInputLabel: "Nachname",
        lastNameIsRequired: "Nachname ist erforderlich",
        emailInputLabel: "E-Mail & Rolle",
        emailIsRequired: "E-Mail ist erforderlich",
        emailMustBeValid: "Muss eine gültige E-Mail sein",
        phoneInputLabel: "Telefonnummer",
        phoneIsRequired: "Telefonnummer ist erforderlich",
        phoneIsInvalid: "Muss eine gültige Telefonnummer sein",
        rolesInputLabel: "Rollen",
        rolesIsRequired: "Mindestens eine Rolle ist erforderlich",
        rolesInputPlaceholder: "Rollen auswählen",
        cancel: "Abbrechen",
        invite: "Einladen"
      },
      users_EditInvitationLink: {
        title: "Mit Link Einstellungen einladen",
        inviteWithLinkTitle: "Mit Link einladen",
        expirationInputLabel: "Ablauf",
        expirationInputPlaceholder: "Bitte wählen Sie eine Option",
        linkExpiration: "Der Link wird in {{days}} ablaufen",
        sendMeNotification: "Schicken Sie mir eine E-Mail, jedes Mal wenn jemand diesen Einladungslink verwendet",
        notification: "Benachrichtigungen",
        deactivateLink: "Link deaktivieren",
        back: "Zurück",
        save: "Speichern",
        copyInviteLink: "Einladungslink kopieren",
        day: "Tag",
        days: "Tage",
        edit: "Bearbeiten"
      },
      users_DeactivateInvitationLink: {
        title: "Link deaktivieren",
        areYouSureDeleteInviteLink: "Sind Sie sicher, dass Sie den Einladungslink deaktivieren möchten?",
        cancel: "Abbrechen",
        deactivate: "Deaktivieren"
      },
      webhooks: {
        pageTitle: "Webhooks",
        searchInputPlaceholder: "Suche nach beliebigem Text...",
        addWebhook: "Webhook hinzufügen",
        searchingPlaceholder: "Webhook-Suche...",
        noResultFound: "Keine Ergebnisse gefunden",
        noResultFoundDescription: "Es scheint, dass wir keine Ergebnisse basierend auf Ihrer Suche finden können.",
        noWebhooksYet: "Sie haben noch keine Webhooks erstellt",
        noWebhooksYetDescription: "Fügen Sie neue Webhooks hinzu, um die Ergebnisse in Ihrer Tabelle zu sehen",
        editWebhook: "Webhook bearbeiten",
        deleteWebhook: "Webhook löschen",
        nameHeader: "Name",
        statusHeader: "Status"
      },
      webhooks_AddEditWebhook: {
        addTitle: "Neuen Webhook hinzufügen",
        editTitle: "Webhook bearbeiten",
        nameInputLabel: "Name",
        nameInputPlaceholder: "Geben Sie den Webhook-Namen ein",
        nameIsRequired: "Webhook-Name ist erforderlich",
        urlInputLabel: "URL",
        urlInputPlaceholder: "https://",
        urlIsRequired: "Webhook-URL ist erforderlich",
        urlIsInvalid: "Muss eine gültige URL sein",
        secretKeyInputLabel: "Geheimschlüssel",
        secretKeyInputPlaceholder: "Geben Sie den Geheimschlüssel ein",
        secretKeyLengthAtLeast8: "Mindestlänge beträgt 8 Zeichen",
        eventsInputLabel: "Ereignisse",
        eventsInputPlaceholder: "Ereignisse auswählen",
        eventsIsRequired: "Mindestens ein Ereignis ist erforderlich",
        cancel: "Abbrechen",
        create: "Erstellen",
        edit: "Update"
      },
      webhooks_DeleteWebhook: {
        title: "Webhook löschen?",
        areYouSureDeleteWebhook1: "Möchten Sie wirklich ",
        areYouSureDeleteWebhook2: "den Webhook löschen? Wenn Sie ihn löschen, können Sie den Vorgang nicht rückgängig machen.",
        cancel: "Abbrechen",
        delete: "Löschen"
      },
      subscriptions: {
        pageTitle: "Abo",
        externallyManaged: "Ihr Abo wird durch einen externen Vertrag verwaltet, kontaktieren Sie uns, um ihn zu ändern",
        currentPlan: "Aktuelles Abo",
        selectedPlan: "Ausgewähltes Abo",
        pricingLink: "Preise",
        paymentMethodTitle: "Bezahlungsmethode",
        invoices: "Rechnungen",
        downloadPdf: "PDF downloaden",
        cancel: "Abbrechen",
        confirm: "Bestätigen",
        update: "Update",
        updatePaymentMethod: "Zahlungsmethode aktualisieren",
        dialogCheckoutTitle: "Checkout",
        dialogSelectionTitle: "Aktualisieren Sie Ihr Abo",
        dialogUpdateBillingDetailsTitle: "Rechnungsinformationen aktualisieren",
        dialogCancellationTitle: "Abo abbrechen",
        dialogRenewalTitle: "Abo erneuern",
        expires: "Läuft ab",
        noBillingDetails: "Keine Abrechnungsinformationen festgelegt",
        setupBillingDetails: "Rechnungsinformationen einrichten",
        emailInputLabel: "E-Mail",
        emailInputPlaceholder: "name@email.de",
        emailIsRequired: "E-Mail ist erforderlich",
        emailMustBeValid: "Muss eine gültige E-Mail sein",
        address1InputLabel: "Adresse 1",
        address1InputPlaceholder: "Adresse 1",
        address1IsRequired: "Adresse 1 ist erforderlich",
        address2InputLabel: "Adresse 2",
        address2InputPlaceholder: "Adresse 2",
        address2IsRequired: "Adresse 2 ist erforderlich",
        cityInputLabel: "Stadt",
        cityInputPlaceholder: "Stadt",
        cityIsRequired: "Stadt ist erforderlich",
        stateInputLabel: "Bundesland",
        stateInputPlaceholder: "Bundesland",
        stateInputIsRequired: "Bundesland ist erforderlich",
        postCodeInputLabel: "Postleitzahl",
        postCodeInputPlaceholder: "Postleitzahl",
        postCodeIsInvalid: "Muss eine gültige Postleitzahl sein",
        postCodeIsRequired: "Postleitzahl ist erforderlich",
        countryInputLabel: "Land",
        countryInputPlaceholder: "Land",
        countryIsRequired: "Land ist erforderlich"
      },
      subscriptions_CurrentPlan: {
        title: "Aktuelles Abo",
        priceSubtitle: "{{price}} pro Monat",
        yourPlanWillBeCanceled: "Ihr Plan wird am {{periodEnd}} gekündigt",
        yourPlanWillBeRenewed: "Ihr Plan wird am {{periodEnd}} erneuert",
        yourPlanIsTrialing: "Ihre Testphase endet am {{periodEnd}}",
        renewalDefault: "Unbekanntes Erneuerungsdatum",
        canceled: "Abgebrochen",
        trialing: "Auf Probe",
        trialEnded: "Testphase beendet",
        cancelButton: "Abo abbrechen",
        renewButton: "Abo erneuern",
        updateButton: "Abo updaten",
        buyNowButton: "Jetzt kaufen",
        unknownPlan: "Unbekanntes Abo"
      },
      subscriptions_DialogSelection: {
        title: "Aktualisieren Sie Ihr Abo",
        currentPlan: "Aktuelles Abo",
        continue: "Fortfahren",
        selectPlanPricePerRecurringInterval: "{{currency}}{{price}} pro {{interval}}"
      },
      subscriptions_Billing: {
        title: "Rechnungsinformationen aktualisieren",
        intervalTitle: "pro {{interval}}",
        intervalMonth: "Monat",
        intervalYear: "Jahr",
        unknownDate: "unbekanntes Datum",
        unknown: "Rechnungsstellung nicht angegeben",
        monthly: "Monatlich abgerechnet",
        paymentMethod: "ZAHLUNGSMETHODE",
        confirmError: "Zahlungsmethode kann nicht verarbeitet werden: {{error}}",
        invalidCardStatusError: "Ungültiger Kartenstatus: {{status}}",
        confirmGenericError: "Neue Zahlungsmethode kann nicht eingerichtet werden"
      },
      subscriptions_Checkout: {
        title: "Checkout",
        paymentMethod: "ZAHLUNGSMETHODE",
        paymentMethodError: "Zahlungsmethode kann beim Checkout nicht verwendet werden",
        nameOnCard: "Name auf der Karte",
        cardNumber: "Kartennummer",
        expiryDate: "Ablaufdatum",
        cvc: "CVC Sicherheitsnummer",
        selectedPlan: "AUSGEWÄHLTES ABO",
        priceIntervalMonthly: "Monatlich abgerechnet"
      },
      subscriptions_Cancellation: {
        title: "Abo abbrechen",
        unknownDate: "Unbekanntes Datum",
        description: "Wenn Sie jetzt kündigen, können Sie weiterhin alle Funktionen Ihres bezahlten Abos bis zum {{expirationDate}} nutzen. Sie können jederzeit erneut abonnieren oder zu einem anderen bezahlten Abo wechseln."
      },
      subscriptions_Renewal: {
        title: "Abo erneuern",
        unknownDate: "Unbekanntes Datum",
        description: "Diese Abo wird nicht mehr storniert. Er wird am {{renewalDate}} erneuert."
      },
      subscriptions_CheckoutDialog: {
        errorPlanNotFound: "Abo wurde nicht gefunden."
      },
      allUsers: {
        pageTitle: "Alle Nutzer",
        inviteUserButton: "Benutzer einladen",
        searchInputPlaceholder: "Suche nach beliebigem Text...",
        searchingPlaceholder: "Suche läuft...",
        meTooltip: "Ich",
        userHeader: "User",
        rolesHeader: "Rollen",
        accountsHeader: "Accounts",
        joinedHeader: "Beigetreten",
        lastSeenHeader: "Zuletzt gesehen",
        manageAction: "Verwalten",
        pendingApprovalStatus: "Ausstehende Genehmigung",
        pendingActivationStatus: "Nicht aktiviert",
        resendInvitationAction: "Einladungsemail erneut senden",
        resendActivationAction: "Aktivierungsemail erneut senden",
        leaveTeamAction: "Team verlassen",
        deleteUserAction: "Löschen",
        lockUserAction: "Sperren",
        noUsersYet: "Sie haben noch keine Benutzer hinzugefügt",
        noUsersYetDescription: "Fügen Sie neue Benutzer hinzu, um die Ergebnisse in Ihrer Tabelle zu sehen",
        noResultFound: "Kein Ergebnis gefunden",
        noResultFoundDescription: "Es scheint, dass wir keine Ergebnisse basierend auf Ihrer Suche finden können."
      },
      allUsers_DeleteUser: {
        title: "{{name}} aus allen Konten löschen?",
        areYouSureDeleteUser1: "Sie sind dabei, {{name}} von allen Konten zu löschen.",
        areYouSureDeleteUser2: "Löschen kann nicht rückgängig gemacht werden",
        cancel: "Abbrechen",
        delete: "Löschen"
      },
      allUsers_LockUser: {
        title: "{{name}} sperren?",
        areYouSureLockUser1: "Möchten Sie wirklich {{name}} sperren?",
        cancel: "Abbrechen",
        lock: "Sperren"
      },
      allUsers_InviteUser: {
        title: "Benutzer einladen",
        inviteWithLinkSettings: "Einladung mit Link-Einstellungen",
        fullNameInputLabel: "Vollständiger Name",
        fullNameIsRequired: "Vollständiger Name ist erforderlich",
        emailInputLabel: "E-Mail",
        emailIsRequired: "E-Mail ist erforderlich",
        emailMustBeValid: "Muss eine gültige E-Mail sein",
        rolesInputLabel: "Rollen",
        rolesIsRequired: "Mindestens eine Rolle ist erforderlich",
        rolesInputPlaceholder: "Rollen auswählen",
        cancel: "Abbrechen",
        invite: "Einladen",
        save: "Speichern",
        selected: "Ausgewählt",
        accountsCount_one: "{{count}} Konto",
        accountsCount_other: "{{count}} Konten",
        assignRole: "Rolle zuweisen",
        accounts: "Konten",
        role: "Rolle"
      },
      allUsers_EditInvitationLink: {
        title: "Einladung mit Link-Einstellungen",
        inviteWithLinkTitle: "Einladung per Link",
        expirationInputLabel: "Ablauf",
        expirationInputPlaceholder: "Bitte wählen Sie eine Option",
        linkExpiration: "Der Link wird in {{days}} ablaufen",
        sendMeNotification: "Schicken Sie mir eine E-Mail, jedes Mal wenn jemand diesen Einladungslink verwendet",
        notification: "Benachrichtigung",
        deactivateLink: "Link deaktivieren",
        back: "Zurück",
        save: "Speichern",
        copyInviteLink: "Einladungslink kopieren",
        day: "Tag",
        days: "Tage",
        edit: "Bearbeiten"
      },
      allUsers_DeactivateInvitationLink: {
        title: "Link deaktivieren",
        areYouSureDeleteInviteLink: "Sind Sie sicher, dass Sie den Einladungslink deaktivieren möchten?",
        cancel: "Abbrechen",
        deactivate: "Deaktivieren"
      }
    }
  }
}, ie = {
  adminPortal: {
    pages: {
      profile: {
        fieldsProperties: {
          phoneNumber: {
            appearance: "hidden"
          }
        }
      },
      privacy: {
        fieldsProperties: {
          loginSessions: {
            appearance: "hidden"
          }
        }
      }
    }
  }
}, re = ({
  children: e,
  isHashRouter: n = !1,
  contextOptions: t
}) => {
  const { locale: r } = J(), i = w(), l = m(
    () => ({
      push(a, o) {
        i(a, { state: o });
      },
      replace(a, o) {
        i(a, { state: o, replace: !0 });
      }
    }),
    [i]
  );
  return m(() => {
    const a = r.slice(0, 2);
    window.localStorage.setItem("frontegg-language", a);
  }, [r]), t.baseUrl ? /* @__PURE__ */ s(
    K,
    {
      contextOptions: t,
      localizations: te,
      themeOptions: ie,
      hostedLoginBox: !1,
      urlStrategy: n ? "hash" : "path",
      history: l,
      children: e
    }
  ) : (console.error(
    "Frontegg base url is not set. It is required for authentication."
  ), /* @__PURE__ */ s("div", { children: "Frontegg base url is not set. It is required for authentication." }));
}, A = "acto.storedSession", se = 4 * 60 * 60 * 1e3;
function ae(e) {
  try {
    return Q(e);
  } catch {
    return null;
  }
}
function oe(e) {
  return typeof e.exp == "number" && typeof e.sub == "string" && typeof e.tenantId == "string" && (e.roles === void 0 || Array.isArray(e.roles));
}
function le() {
  try {
    const e = window.localStorage.getItem(A);
    if (!e) return null;
    const { accessToken: n, tenantName: t } = JSON.parse(
      e
    );
    return typeof n != "string" ? null : {
      accessToken: n,
      tenantName: typeof t == "string" ? t : ""
    };
  } catch {
    return null;
  }
}
function de(e) {
  const n = le();
  if (!n) return null;
  const t = ae(n.accessToken);
  if (!t || !oe(t)) return null;
  const r = t.exp * 1e3;
  if (r - e < se) return null;
  const i = t.roles ?? [];
  return {
    ...n,
    expiresAt: r,
    user: X({ ...t, roles: i }),
    accessClaims: {
      tenantId: t.tenantId,
      roles: i,
      metadata: t.metadata
    }
  };
}
function ue(e) {
  try {
    window.localStorage.setItem(A, JSON.stringify(e));
  } catch (n) {
    console.warn(
      "[auth] storage blocked, the session will not survive a reload",
      n
    );
  }
}
function N() {
  try {
    window.localStorage.removeItem(A);
  } catch (e) {
    console.warn(
      "[auth] storage blocked, could not clear the stored session",
      e
    );
  }
}
const ce = () => {
  const { accessToken: e, tenantName: n } = v();
  return f(() => {
    e ? ue({ accessToken: e, tenantName: n }) : N();
  }, [e, n]), null;
};
async function he(e, n, t, r) {
  try {
    const i = await fetch(pe(e), {
      headers: { authorization: `Bearer ${n}` },
      signal: r
    });
    if (i.status === 401 || i.status === 403)
      return console.warn(
        `[auth] Frontegg rejected the stored token (HTTP ${i.status}), signing out`
      ), "stale";
    if (!i.ok)
      return console.warn(
        `[auth] Frontegg could not check the stored session (HTTP ${i.status}), keeping it`
      ), "unknown";
    const l = await i.json(), a = ge(l.metadata), o = me(t, l, a);
    return o ? (console.warn(
      `[auth] the stored token's ${o} no longer matches the Frontegg profile, signing out`
    ), "stale") : "current";
  } catch (i) {
    return r.aborted || console.warn(
      "[auth] could not check the stored session against Frontegg, keeping it",
      i
    ), "unknown";
  }
}
function pe(e) {
  return `${e.replace(/\/+$/, "")}/frontegg/identity/resources/users/v2/me`;
}
function ge(e) {
  return e ? JSON.parse(e) : {};
}
function me(e, n, t) {
  return e.tenantId !== n.tenantId ? "tenantId" : be(
    e.roles,
    n.roles.map((r) => r.key)
  ) ? M(e.metadata) !== M(t) ? "metadata" : null : "roles";
}
function be(e, n) {
  const t = (r) => JSON.stringify(Array.from(new Set(r)).sort());
  return t(e) === t(n);
}
function M(e) {
  return JSON.stringify(
    e ?? {},
    (n, t) => t && typeof t == "object" && !Array.isArray(t) ? Object.fromEntries(
      Object.entries(t).sort(
        ([r], [i]) => r.localeCompare(i)
      )
    ) : t
  );
}
const R = 5 * 60 * 1e3, Ie = ({
  children: e,
  fronteggBaseUrl: n,
  fronteggFallback: t,
  unauthorizedPageRedirectUrl: r
}) => {
  const [i, l] = O(() => {
    const d = de(Date.now());
    return d ? { kind: "stored", session: d } : { kind: "frontegg" };
  }), a = w(), o = c(() => l({ kind: "frontegg" }), []), h = c(() => a("/"), [a]), u = c(() => {
    N(), o();
  }, [o]);
  f(() => {
    if (i.kind !== "stored") return;
    const d = setTimeout(
      o,
      i.session.expiresAt - Date.now()
    );
    return () => clearTimeout(d);
  }, [i, o]), f(() => {
    if (i.kind !== "stored") return;
    const { accessToken: d, accessClaims: g } = i.session, b = new AbortController();
    let L = 0;
    const I = async () => {
      if (document.visibilityState === "hidden") return;
      L = Date.now(), await he(
        n,
        d,
        g,
        b.signal
      ) === "stale" && !b.signal.aborted && u();
    }, P = () => {
      Date.now() - L >= R && I();
    };
    I();
    const q = setInterval(
      () => void I(),
      R
    );
    return document.addEventListener("visibilitychange", P), () => {
      b.abort(), clearInterval(q), document.removeEventListener("visibilitychange", P);
    };
  }, [i, n, u]);
  const p = m(
    () => i.kind === "stored" ? {
      user: i.session.user,
      accessToken: i.session.accessToken,
      logout: u,
      login: h,
      loginUrl: "",
      isAuthenticated: !0,
      unauthorizedPageRedirectUrl: r,
      tenantName: i.session.tenantName
    } : null,
    [i, u, h, r]
  );
  return p ? /* @__PURE__ */ s(y.Provider, { value: p, children: e }) : /* @__PURE__ */ s(U, { children: t });
};
function fe(e) {
  if (!e.frontegg.baseUrl)
    throw new Error(
      "createAuthRouter: frontegg.baseUrl is empty, so the app cannot sign users in. Set VITE_FRONTEGG_BASE_URL in the app's .env (see .env.example)."
    );
  const n = /* @__PURE__ */ s(
    re,
    {
      contextOptions: e.frontegg,
      isHashRouter: e.urlStrategy === "hash",
      children: /* @__PURE__ */ C(
        ee,
        {
          unauthorizedPageRedirectUrl: e.unauthorizedPageRedirectUrl,
          children: [
            e.persistSessionInFrame && /* @__PURE__ */ s(ce, {}),
            /* @__PURE__ */ s(k, {})
          ]
        }
      )
    }
  );
  return e.persistSessionInFrame ? /* @__PURE__ */ s(
    Ie,
    {
      fronteggBaseUrl: e.frontegg.baseUrl,
      fronteggFallback: n,
      unauthorizedPageRedirectUrl: e.unauthorizedPageRedirectUrl,
      children: /* @__PURE__ */ s(k, {})
    }
  ) : n;
}
function Me(e, n) {
  return (n.urlStrategy === "hash" ? V : Z)(
    j(
      /* @__PURE__ */ C(T, { element: fe(n), children: [
        e,
        /* @__PURE__ */ s(
          T,
          {
            path: "*",
            element: /* @__PURE__ */ s(ne, { redirectTarget: n.notFoundRedirectRoute })
          }
        )
      ] })
    )
  );
}
export {
  y as AuthContext,
  ee as AuthContextProvider,
  ne as NotFoundRedirect,
  Te as ProtectedRoute,
  D as Role,
  B as User,
  N as clearStoredSession,
  Me as createAuthRouter,
  v as useAuthContext
};
//# sourceMappingURL=auth.js.map
